var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachineSlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 674,
    height: 191,
    viewBox: "0 0 674 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M619.649 178.5H58.1159C35.3777 178.5 16.8826 168.527 16.8826 156.277V34.7233C16.8826 22.4635 35.3777 12.5 58.1159 12.5H619.649C642.388 12.5 660.883 22.4635 660.883 34.7233V156.237C660.883 168.527 642.388 178.5 619.649 178.5Z",
    fill: "url(#paint0_linear_1825_22010)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M619.44 178.5H54.333C29.2756 178.5 8.88257 167.852 8.88257 154.764V36.2363C8.88257 23.1477 29.2756 12.5 54.333 12.5H619.481C644.498 12.5 664.883 23.1477 664.883 36.2363V154.725C664.883 167.852 644.498 178.5 619.44 178.5ZM54.333 16.6226C33.6356 16.6226 16.7881 25.4252 16.7881 36.2363V154.725C16.7881 165.536 33.6356 174.329 54.333 174.329H619.481C640.179 174.329 657.018 165.536 657.018 154.725V36.2363C657.018 25.4252 640.179 16.6226 619.481 16.6226H54.333Z",
    fill: "url(#paint1_linear_1825_22010)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7753 152.5C48.8681 152.5 44.8826 150.612 44.8826 148.286V42.7136C44.8826 40.3976 48.8762 38.5 53.7753 38.5H617.99C622.897 38.5 626.883 40.3976 626.883 42.7136V148.286C626.883 150.612 622.889 152.5 617.99 152.5H53.7753Z",
    fill: "url(#paint2_radial_1825_22010)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M616.99 39.3964C620.224 39.3964 622.908 40.6225 622.908 42.1286V146.871C622.908 148.387 620.257 149.613 616.99 149.613H52.7747C49.5409 149.613 46.8569 148.387 46.8569 146.871V42.1286C46.8569 40.6225 49.5167 39.3964 52.7747 39.3964H616.99ZM616.99 36.5H52.7747C46.2182 36.5 40.8826 39.0198 40.8826 42.119V146.871C40.8826 149.98 46.2182 152.5 52.7747 152.5H616.99C623.547 152.5 628.883 149.98 628.883 146.871V42.1286C628.883 39.0295 623.547 36.5097 616.99 36.5097V36.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M59.4743 27.8981C59.4743 29.8172 58.9053 31.6932 57.839 33.2889C56.7728 34.8846 55.2574 36.1283 53.4844 36.8627C51.7113 37.5971 49.7603 37.7892 47.8781 37.4148C45.9959 37.0404 44.2669 36.1163 42.9099 34.7593C41.5529 33.4023 40.6287 31.6733 40.2543 29.7911C39.8799 27.9088 40.0721 25.9578 40.8065 24.1848C41.5409 22.4118 42.7846 20.8963 44.3803 19.8301C45.976 18.7639 47.852 18.1948 49.7711 18.1948C52.3446 18.1948 54.8126 19.2171 56.6323 21.0368C58.452 22.8565 59.4743 25.3246 59.4743 27.8981Z",
    fill: "url(#paint3_radial_1825_22010)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1509 27.9063C56.1493 29.1677 55.7737 30.4004 55.0717 31.4485C54.3697 32.4966 53.3728 33.3131 52.2069 33.7947C51.041 34.2764 49.7584 34.4016 48.5214 34.1545C47.2843 33.9074 46.1483 33.2991 45.2569 32.4066C44.3655 31.514 43.7586 30.3772 43.5131 29.1399C43.2676 27.9025 43.3944 26.6201 43.8775 25.4548C44.3606 24.2895 45.1784 23.2936 46.2274 22.593C47.2763 21.8923 48.5095 21.5183 49.771 21.5183C50.6095 21.5183 51.4398 21.6836 52.2143 22.0047C52.9889 22.3258 53.6926 22.7965 54.2851 23.3898C54.8776 23.9831 55.3474 24.6873 55.6675 25.4623C55.9877 26.2373 56.1519 27.0678 56.1509 27.9063Z",
    fill: "url(#paint4_radial_1825_22010)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3095 26.467C55.3111 27.7151 54.9424 28.9356 54.2499 29.9741C53.5575 31.0125 52.5726 31.8222 51.4198 32.3005C50.267 32.7789 48.9982 32.9045 47.7739 32.6614C46.5497 32.4183 45.4252 31.8174 44.5426 30.9349C43.6601 30.0523 43.0592 28.9278 42.8161 27.7035C42.573 26.4793 42.6986 25.2105 43.177 24.0577C43.6553 22.9049 44.465 21.92 45.5034 21.2275C46.5419 20.5351 47.7624 20.1664 49.0105 20.168C50.6811 20.168 52.2833 20.8316 53.4646 22.0129C54.6459 23.1942 55.3095 24.7964 55.3095 26.467Z",
    fill: "url(#paint5_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M38.9111 36.1703C38.9111 38.0894 38.342 39.9654 37.2758 41.5611C36.2096 43.1568 34.6942 44.4005 32.9211 45.1349C31.1481 45.8693 29.1971 46.0615 27.3149 45.6871C25.4326 45.3127 23.7037 44.3885 22.3467 43.0315C20.9896 41.6745 20.0655 39.9455 19.6911 38.0633C19.3167 36.181 19.5088 34.23 20.2433 32.457C20.9777 30.684 22.2214 29.1685 23.817 28.1023C25.4127 27.0361 27.2888 26.467 29.2079 26.467C31.7813 26.467 34.2494 27.4893 36.0691 29.3091C37.8888 31.1288 38.9111 33.5968 38.9111 36.1703Z",
    fill: "url(#paint6_radial_1825_22010)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5796 36.1702C35.5764 37.432 35.199 38.6646 34.4954 39.712C33.7917 40.7593 32.7932 41.5745 31.6262 42.0545C30.4592 42.5344 29.1761 42.6575 27.9392 42.4082C26.7022 42.1588 25.567 41.5483 24.677 40.6538C23.7871 39.7593 23.1823 38.621 22.9393 37.3828C22.6962 36.1446 22.8258 34.8622 23.3117 33.6976C23.7975 32.5331 24.6177 31.5388 25.6687 30.8404C26.7196 30.142 27.954 29.771 29.2159 29.7742C30.054 29.7752 30.8836 29.9416 31.6574 30.2638C32.4311 30.5861 33.1336 31.0577 33.7248 31.6519C34.3159 32.246 34.784 32.9509 35.1023 33.7263C35.4206 34.5016 35.5827 35.3321 35.5796 36.1702Z",
    fill: "url(#paint7_radial_1825_22010)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7714 34.7309C34.773 35.979 34.4043 37.1995 33.7119 38.238C33.0194 39.2764 32.0345 40.0861 30.8817 40.5644C29.7289 41.0428 28.4601 41.1684 27.2359 40.9253C26.0116 40.6822 24.8871 40.0813 24.0045 39.1988C23.122 38.3162 22.5211 37.1917 22.278 35.9675C22.0349 34.7432 22.1605 33.4744 22.6389 32.3216C23.1172 31.1688 23.9269 30.1839 24.9653 29.4915C26.0038 28.799 27.2243 28.4303 28.4724 28.4319C30.143 28.4319 31.7452 29.0955 32.9265 30.2768C34.1078 31.4581 34.7714 33.0603 34.7714 34.7309Z",
    fill: "url(#paint8_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M38.9111 62.3526C38.9111 64.2718 38.342 66.1478 37.2758 67.7435C36.2096 69.3392 34.6942 70.5828 32.9211 71.3173C31.1481 72.0517 29.1971 72.2438 27.3149 71.8694C25.4326 71.495 23.7037 70.5709 22.3467 69.2139C20.9896 67.8568 20.0655 66.1279 19.6911 64.2456C19.3167 62.3634 19.5088 60.4124 20.2433 58.6394C20.9777 56.8663 22.2214 55.3509 23.817 54.2847C25.4127 53.2185 27.2888 52.6494 29.2079 52.6494C31.7813 52.6494 34.2494 53.6717 36.0691 55.4914C37.8888 57.3111 38.9111 59.7792 38.9111 62.3526Z",
    fill: "url(#paint9_radial_1825_22010)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5796 62.3528C35.5796 63.6146 35.2054 64.8481 34.5044 65.8972C33.8033 66.9464 32.8069 67.7641 31.6412 68.247C30.4754 68.7299 29.1926 68.8562 27.955 68.6101C26.7175 68.3639 25.5807 67.7563 24.6884 66.864C23.7962 65.9718 23.1886 64.835 22.9424 63.5974C22.6962 62.3598 22.8226 61.0771 23.3055 59.9113C23.7883 58.7455 24.6061 57.7491 25.6552 57.0481C26.7044 56.3471 27.9379 55.9729 29.1997 55.9729C30.8917 55.9729 32.5145 56.6451 33.711 57.8415C34.9074 59.038 35.5796 60.6607 35.5796 62.3528Z",
    fill: "url(#paint10_radial_1825_22010)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7714 60.9216C34.7714 62.1694 34.4013 63.3891 33.7079 64.4265C33.0145 65.4639 32.029 66.2722 30.8761 66.7494C29.7231 67.2265 28.4546 67.3509 27.2309 67.1069C26.0072 66.8629 24.8834 66.2614 24.0017 65.3785C23.1199 64.4957 22.5199 63.3711 22.2774 62.1471C22.035 60.9231 22.161 59.6547 22.6397 58.5024C23.1183 57.35 23.9279 56.3656 24.9662 55.6735C26.0044 54.9814 27.2246 54.6129 28.4724 54.6145C29.3003 54.6145 30.1201 54.7777 30.8848 55.0948C31.6496 55.4118 32.3443 55.8765 32.9294 56.4623C33.5144 57.0481 33.9782 57.7434 34.2943 58.5086C34.6103 59.2738 34.7725 60.0937 34.7714 60.9216Z",
    fill: "url(#paint11_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M38.9111 88.5353C38.9111 90.4544 38.342 92.3304 37.2758 93.9261C36.2096 95.5218 34.6942 96.7655 32.9211 97.4999C31.1481 98.2343 29.1971 98.4265 27.3149 98.052C25.4326 97.6776 23.7037 96.7535 22.3467 95.3965C20.9896 94.0395 20.0655 92.3105 19.6911 90.4283C19.3167 88.546 19.5088 86.595 20.2433 84.822C20.9777 83.049 22.2214 81.5335 23.817 80.4673C25.4127 79.4011 27.2888 78.832 29.2079 78.832C31.7813 78.832 34.2494 79.8543 36.0691 81.674C37.8888 83.4937 38.9111 85.9618 38.9111 88.5353Z",
    fill: "url(#paint12_radial_1825_22010)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5796 88.5435C35.578 89.805 35.2024 91.0376 34.5004 92.0857C33.7984 93.1338 32.8015 93.9503 31.6356 94.432C30.4697 94.9136 29.1871 95.0388 27.9501 94.7917C26.7131 94.5446 25.577 93.9364 24.6856 93.0438C23.7942 92.1512 23.1873 91.0144 22.9418 89.7771C22.6963 88.5397 22.8231 87.2574 23.3062 86.0921C23.7894 84.9268 24.6071 83.9308 25.6561 83.2302C26.7051 82.5295 27.9382 82.1555 29.1997 82.1555C30.0385 82.1545 30.8692 82.319 31.6443 82.6398C32.4193 82.9605 33.1234 83.4311 33.7162 84.0246C34.3089 84.6181 34.7787 85.3228 35.0984 86.0983C35.4182 86.8737 35.5817 87.7047 35.5796 88.5435Z",
    fill: "url(#paint13_radial_1825_22010)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7714 87.104C34.773 88.3521 34.4043 89.5726 33.7119 90.611C33.0194 91.6495 32.0345 92.4591 30.8817 92.9375C29.7289 93.4159 28.4601 93.5414 27.2359 93.2983C26.0116 93.0552 24.8871 92.4544 24.0045 91.5718C23.122 90.6893 22.5211 89.5647 22.278 88.3405C22.0349 87.1163 22.1605 85.8475 22.6389 84.6947C23.1172 83.5419 23.9269 82.5569 24.9653 81.8645C26.0038 81.1721 27.2243 80.8033 28.4724 80.8049C30.143 80.8049 31.7452 81.4686 32.9265 82.6499C34.1078 83.8312 34.7714 85.4333 34.7714 87.104Z",
    fill: "url(#paint14_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M38.9111 114.726C38.9111 116.645 38.342 118.521 37.2758 120.117C36.2096 121.712 34.6942 122.956 32.9211 123.69C31.1481 124.425 29.1971 124.617 27.3149 124.242C25.4326 123.868 23.7037 122.944 22.3467 121.587C20.9896 120.23 20.0655 118.501 19.6911 116.619C19.3167 114.736 19.5088 112.785 20.2433 111.012C20.9777 109.239 22.2214 107.724 23.817 106.658C25.4127 105.592 27.2888 105.022 29.2079 105.022C31.7813 105.022 34.2494 106.045 36.0691 107.864C37.8888 109.684 38.9111 112.152 38.9111 114.726Z",
    fill: "url(#paint15_radial_1825_22010)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5796 114.726C35.5796 115.988 35.2054 117.221 34.5044 118.271C33.8033 119.32 32.8069 120.137 31.6412 120.62C30.4754 121.103 29.1926 121.23 27.955 120.983C26.7175 120.737 25.5807 120.13 24.6884 119.237C23.7962 118.345 23.1886 117.208 22.9424 115.971C22.6962 114.733 22.8226 113.45 23.3055 112.285C23.7883 111.119 24.6061 110.122 25.6552 109.421C26.7044 108.72 27.9379 108.346 29.1997 108.346C30.8917 108.346 32.5145 109.018 33.711 110.215C34.9074 111.411 35.5796 113.034 35.5796 114.726Z",
    fill: "url(#paint16_radial_1825_22010)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7714 113.295C34.7714 114.543 34.4013 115.762 33.7079 116.8C33.0145 117.837 32.029 118.646 30.8761 119.123C29.7231 119.6 28.4546 119.724 27.2309 119.48C26.0072 119.236 24.8834 118.635 24.0017 117.752C23.1199 116.869 22.5199 115.744 22.2774 114.52C22.035 113.296 22.161 112.028 22.6397 110.876C23.1183 109.723 23.9279 108.739 24.9662 108.047C26.0044 107.355 27.2246 106.986 28.4724 106.988C29.3003 106.988 30.1201 107.151 30.8848 107.468C31.6496 107.785 32.3443 108.25 32.9294 108.836C33.5144 109.421 33.9782 110.117 34.2943 110.882C34.6103 111.647 34.7725 112.467 34.7714 113.295Z",
    fill: "url(#paint17_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M40.7712 140.908C40.7712 142.827 40.2021 144.703 39.1359 146.299C38.0697 147.895 36.5543 149.139 34.7812 149.873C33.0082 150.607 31.0572 150.799 29.175 150.425C27.2927 150.051 25.5638 149.127 24.2068 147.77C22.8497 146.413 21.9256 144.684 21.5512 142.801C21.1768 140.919 21.369 138.968 22.1034 137.195C22.8378 135.422 24.0815 133.907 25.6772 132.84C27.2728 131.774 29.1489 131.205 31.068 131.205C33.6414 131.205 36.1095 132.227 37.9292 134.047C39.7489 135.867 40.7712 138.335 40.7712 140.908Z",
    fill: "url(#paint18_radial_1825_22010)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4475 140.917C37.4459 142.179 37.0702 143.412 36.3678 144.46C35.6654 145.508 34.668 146.325 33.5016 146.806C32.3352 147.287 31.0523 147.412 29.815 147.164C28.5778 146.917 27.4418 146.308 26.5507 145.414C25.6595 144.521 25.0534 143.383 24.8088 142.145C24.5642 140.908 24.6921 139.625 25.1765 138.46C25.6608 137.295 26.4798 136.299 27.5299 135.6C28.5799 134.9 29.8139 134.527 31.0757 134.529C31.9141 134.528 32.7445 134.692 33.5191 135.013C34.2937 135.334 34.9973 135.805 35.5894 136.398C36.1815 136.992 36.6504 137.697 36.9693 138.472C37.2882 139.248 37.4507 140.078 37.4475 140.917Z",
    fill: "url(#paint19_radial_1825_22010)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6149 139.477C36.6165 140.725 36.2478 141.946 35.5554 142.984C34.8629 144.023 33.878 144.832 32.7252 145.311C31.5724 145.789 30.3036 145.915 29.0794 145.672C27.8552 145.429 26.7306 144.828 25.848 143.945C24.9655 143.063 24.3646 141.938 24.1215 140.714C23.8784 139.49 24.004 138.221 24.4824 137.068C24.9608 135.915 25.7704 134.93 26.8088 134.238C27.8473 133.545 29.0678 133.177 30.3159 133.178C31.9865 133.178 33.5887 133.842 34.77 135.023C35.9513 136.204 36.6149 137.807 36.6149 139.477Z",
    fill: "url(#paint20_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M634.487 34.5531C634.487 36.4722 635.056 38.3482 636.122 39.9439C637.188 41.5396 638.704 42.7833 640.477 43.5177C642.25 44.2521 644.201 44.4443 646.083 44.0699C647.965 43.6955 649.694 42.7713 651.051 41.4143C652.408 40.0573 653.332 38.3283 653.707 36.4461C654.081 34.5638 653.889 32.6129 653.155 30.8398C652.42 29.0668 651.177 27.5513 649.581 26.4851C647.985 25.4189 646.109 24.8499 644.19 24.8499C641.617 24.8499 639.149 25.8722 637.329 27.6919C635.509 29.5116 634.487 31.9796 634.487 34.5531Z",
    fill: "url(#paint21_radial_1825_22010)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M637.811 34.553C637.813 35.8148 638.188 37.0478 638.891 38.0961C639.593 39.1444 640.591 39.9608 641.757 40.4422C642.923 40.9236 644.206 41.0484 645.443 40.8006C646.681 40.5529 647.817 39.9438 648.708 39.0504C649.599 38.1571 650.205 37.0195 650.45 35.7816C650.694 34.5437 650.566 33.2611 650.082 32.096C649.598 30.9308 648.779 29.9355 647.729 29.2358C646.679 28.5361 645.445 28.1634 644.183 28.165C643.345 28.165 642.515 28.3304 641.741 28.6516C640.967 28.9728 640.263 29.4436 639.672 30.037C639.08 30.6304 638.611 31.3347 638.291 32.1097C637.972 32.8846 637.809 33.7149 637.811 34.553Z",
    fill: "url(#paint22_radial_1825_22010)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M638.651 33.1137C638.65 34.3618 639.019 35.5824 639.711 36.6208C640.403 37.6592 641.388 38.4689 642.541 38.9473C643.694 39.4256 644.963 39.5512 646.187 39.3081C647.411 39.065 648.536 38.4641 649.418 37.5816C650.301 36.699 650.902 35.5745 651.145 34.3503C651.388 33.1261 651.262 31.8572 650.784 30.7044C650.306 29.5516 649.496 28.5667 648.457 27.8743C647.419 27.1819 646.198 26.8131 644.95 26.8147C644.123 26.8136 643.303 26.9758 642.539 27.292C641.774 27.6082 641.079 28.0721 640.494 28.6573C639.909 29.2424 639.445 29.9372 639.129 30.7019C638.812 31.4666 638.65 32.2862 638.651 33.1137Z",
    fill: "url(#paint23_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M634.487 60.7355C634.487 62.6546 635.056 64.5306 636.122 66.1263C637.188 67.722 638.704 68.9657 640.477 69.7001C642.25 70.4345 644.201 70.6266 646.083 70.2522C647.965 69.8778 649.694 68.9537 651.051 67.5967C652.408 66.2397 653.332 64.5107 653.707 62.6285C654.081 60.7462 653.889 58.7952 653.155 57.0222C652.42 55.2492 651.177 53.7337 649.581 52.6675C647.985 51.6013 646.109 51.0322 644.19 51.0322C641.617 51.0322 639.149 52.0545 637.329 53.8742C635.509 55.6939 634.487 58.162 634.487 60.7355Z",
    fill: "url(#paint24_radial_1825_22010)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M637.811 60.7356C637.811 61.9978 638.185 63.2316 638.887 64.2809C639.588 65.3302 640.585 66.148 641.751 66.6306C642.918 67.1132 644.201 67.2391 645.439 66.9923C646.676 66.7455 647.813 66.137 648.705 65.244C649.597 64.3509 650.204 63.2134 650.449 61.9753C650.694 60.7372 650.567 59.4541 650.083 58.2885C649.599 57.1229 648.78 56.127 647.729 55.427C646.679 54.7269 645.445 54.3541 644.183 54.3557C642.492 54.3579 640.871 55.031 639.677 56.2272C638.482 57.4234 637.811 59.0449 637.811 60.7356Z",
    fill: "url(#paint25_radial_1825_22010)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M638.651 59.3044C638.651 60.5522 639.022 61.7719 639.715 62.8093C640.408 63.8467 641.394 64.6551 642.547 65.1322C643.7 65.6093 644.968 65.7338 646.192 65.4897C647.416 65.2457 648.539 64.6442 649.421 63.7613C650.303 62.8785 650.903 61.7539 651.145 60.5299C651.388 59.3059 651.262 58.0375 650.783 56.8852C650.305 55.7329 649.495 54.7484 648.457 54.0563C647.418 53.3643 646.198 52.9957 644.95 52.9973C644.122 52.9963 643.302 53.1587 642.537 53.4754C641.771 53.7921 641.076 54.2568 640.491 54.8427C639.906 55.4287 639.442 56.1245 639.126 56.8901C638.811 57.6558 638.649 58.4762 638.651 59.3044Z",
    fill: "url(#paint26_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M634.487 86.9181C634.487 88.8372 635.056 90.7132 636.122 92.3089C637.188 93.9046 638.704 95.1483 640.477 95.8827C642.25 96.6171 644.201 96.8093 646.083 96.4349C647.965 96.0605 649.694 95.1363 651.051 93.7793C652.408 92.4223 653.332 90.6933 653.707 88.8111C654.081 86.9288 653.889 84.9778 653.155 83.2048C652.42 81.4318 651.177 79.9163 649.581 78.8501C647.985 77.7839 646.109 77.2148 644.19 77.2148C641.617 77.2148 639.149 78.2371 637.329 80.0569C635.509 81.8766 634.487 84.3446 634.487 86.9181Z",
    fill: "url(#paint27_radial_1825_22010)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M637.811 86.9261C637.813 88.1879 638.188 89.4209 638.891 90.4692C639.593 91.5174 640.591 92.3339 641.757 92.8153C642.923 93.2967 644.206 93.4214 645.443 93.1737C646.681 92.9259 647.817 92.3169 648.708 91.4235C649.599 90.5301 650.205 89.3926 650.45 88.1547C650.694 86.9168 650.566 85.6342 650.082 84.469C649.598 83.3039 648.779 82.3085 647.729 81.6088C646.679 80.9091 645.445 80.5365 644.183 80.5381C643.345 80.5381 642.515 80.7034 641.741 81.0247C640.967 81.3459 640.263 81.8167 639.672 82.4101C639.08 83.0034 638.611 83.7078 638.291 84.4827C637.972 85.2576 637.809 86.0879 637.811 86.9261Z",
    fill: "url(#paint28_radial_1825_22010)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M638.651 85.487C638.65 86.7351 639.019 87.9556 639.711 88.9941C640.403 90.0325 641.388 90.8422 642.541 91.3205C643.694 91.7989 644.963 91.9245 646.187 91.6814C647.411 91.4383 648.536 90.8374 649.418 89.9549C650.301 89.0723 650.902 87.9478 651.145 86.7236C651.388 85.4993 651.262 84.2305 650.784 83.0777C650.306 81.9249 649.496 80.94 648.457 80.2476C647.419 79.5551 646.198 79.1864 644.95 79.188C644.123 79.1869 643.303 79.3491 642.539 79.6653C641.774 79.9815 641.079 80.4454 640.494 81.0306C639.909 81.6157 639.445 82.3105 639.129 83.0752C638.812 83.8399 638.65 84.6595 638.651 85.487Z",
    fill: "url(#paint29_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M634.487 113.109C634.487 115.028 635.056 116.904 636.122 118.499C637.188 120.095 638.704 121.339 640.477 122.073C642.25 122.808 644.201 123 646.083 122.625C647.965 122.251 649.694 121.327 651.051 119.97C652.408 118.613 653.332 116.884 653.707 115.002C654.081 113.119 653.889 111.168 653.155 109.395C652.42 107.622 651.177 106.107 649.581 105.041C647.985 103.974 646.109 103.405 644.19 103.405C641.617 103.405 639.149 104.428 637.329 106.247C635.509 108.067 634.487 110.535 634.487 113.109Z",
    fill: "url(#paint30_radial_1825_22010)"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M637.811 113.109C637.811 114.371 638.185 115.605 638.887 116.654C639.588 117.704 640.585 118.521 641.751 119.004C642.918 119.487 644.201 119.612 645.439 119.366C646.676 119.119 647.813 118.51 648.705 117.617C649.597 116.724 650.204 115.587 650.449 114.349C650.694 113.11 650.567 111.827 650.083 110.662C649.599 109.496 648.78 108.5 647.729 107.8C646.679 107.1 645.445 106.727 644.183 106.729C642.492 106.731 640.871 107.404 639.677 108.6C638.482 109.797 637.811 111.418 637.811 113.109Z",
    fill: "url(#paint31_radial_1825_22010)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M638.651 111.678C638.651 112.925 639.022 114.145 639.715 115.183C640.408 116.22 641.394 117.028 642.547 117.505C643.7 117.983 644.968 118.107 646.192 117.863C647.416 117.619 648.539 117.018 649.421 116.135C650.303 115.252 650.903 114.127 651.145 112.903C651.388 111.679 651.262 110.411 650.783 109.258C650.305 108.106 649.495 107.122 648.457 106.43C647.418 105.738 646.198 105.369 644.95 105.371C644.122 105.37 643.302 105.532 642.537 105.849C641.771 106.165 641.076 106.63 640.491 107.216C639.906 107.802 639.442 108.498 639.126 109.263C638.811 110.029 638.649 110.85 638.651 111.678Z",
    fill: "url(#paint32_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M632.627 139.291C632.627 141.21 633.197 143.086 634.263 144.682C635.329 146.278 636.844 147.521 638.617 148.256C640.39 148.99 642.341 149.182 644.224 148.808C646.106 148.434 647.835 147.509 649.192 146.152C650.549 144.795 651.473 143.066 651.847 141.184C652.222 139.302 652.03 137.351 651.295 135.578C650.561 133.805 649.317 132.289 647.722 131.223C646.126 130.157 644.25 129.588 642.331 129.588C639.757 129.588 637.289 130.61 635.469 132.43C633.65 134.25 632.627 136.718 632.627 139.291Z",
    fill: "url(#paint33_radial_1825_22010)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M635.951 139.299C635.953 140.561 636.328 141.794 637.031 142.842C637.733 143.89 638.73 144.707 639.897 145.188C641.063 145.67 642.346 145.794 643.583 145.547C644.821 145.299 645.957 144.69 646.848 143.797C647.739 142.903 648.345 141.766 648.59 140.528C648.834 139.29 648.706 138.007 648.222 136.842C647.738 135.677 646.919 134.682 645.869 133.982C644.819 133.282 643.585 132.91 642.323 132.911C641.484 132.91 640.654 133.075 639.879 133.396C639.105 133.716 638.401 134.187 637.809 134.781C637.217 135.374 636.748 136.079 636.429 136.854C636.11 137.63 635.948 138.461 635.951 139.299Z",
    fill: "url(#paint34_radial_1825_22010)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M636.792 137.86C636.79 139.108 637.159 140.329 637.851 141.367C638.544 142.406 639.529 143.215 640.681 143.694C641.834 144.172 643.103 144.298 644.327 144.054C645.552 143.811 646.676 143.21 647.559 142.328C648.441 141.445 649.042 140.321 649.285 139.097C649.528 137.872 649.403 136.604 648.924 135.451C648.446 134.298 647.636 133.313 646.598 132.621C645.559 131.928 644.339 131.559 643.091 131.561C642.263 131.56 641.444 131.722 640.679 132.038C639.914 132.355 639.219 132.818 638.634 133.404C638.049 133.989 637.585 134.684 637.269 135.448C636.953 136.213 636.791 137.033 636.792 137.86Z",
    fill: "url(#paint35_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M86.8454 27.8981C86.8454 29.8172 86.2763 31.6932 85.2101 33.2889C84.1439 34.8846 82.6285 36.1283 80.8555 36.8627C79.0824 37.5971 77.1314 37.7892 75.2492 37.4148C73.3669 37.0404 71.638 36.1163 70.281 34.7593C68.924 33.4023 67.9998 31.6733 67.6254 29.7911C67.251 27.9088 67.4432 25.9578 68.1776 24.1848C68.912 22.4118 70.1557 20.8963 71.7514 19.8301C73.3471 18.7639 75.2231 18.1948 77.1422 18.1948C79.7157 18.1948 82.1837 19.2171 84.0034 21.0368C85.8231 22.8565 86.8454 25.3246 86.8454 27.8981Z",
    fill: "url(#paint36_radial_1825_22010)"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M83.522 27.9063C83.5204 29.1681 83.1446 30.4011 82.4423 31.4494C81.7399 32.4976 80.7425 33.3141 79.5761 33.7955C78.4097 34.2769 77.1268 34.4016 75.8895 34.1539C74.6522 33.9061 73.5162 33.2971 72.6251 32.4037C71.734 31.5103 71.1278 30.3728 70.8832 29.1349C70.6386 27.897 70.7666 26.6144 71.2509 25.4492C71.7353 24.2841 72.5543 23.2887 73.6043 22.589C74.6544 21.8893 75.8883 21.5167 77.1502 21.5183C77.9883 21.5183 78.8182 21.6837 79.5923 22.0049C80.3664 22.3261 81.0695 22.7969 81.6614 23.3903C82.2533 23.9837 82.7223 24.688 83.0416 25.4629C83.3608 26.2379 83.5241 27.0682 83.522 27.9063Z",
    fill: "url(#paint37_radial_1825_22010)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6811 26.467C82.6827 27.7151 82.3139 28.9356 81.6215 29.9741C80.9291 31.0125 79.9442 31.8222 78.7914 32.3005C77.6386 32.7789 76.3697 32.9045 75.1455 32.6614C73.9213 32.4183 72.7968 31.8174 71.9142 30.9349C71.0317 30.0523 70.4308 28.9278 70.1877 27.7035C69.9446 26.4793 70.0702 25.2105 70.5485 24.0577C71.0269 22.9049 71.8366 21.92 72.875 21.2275C73.9134 20.5351 75.134 20.1664 76.3821 20.168C77.2096 20.1669 78.0292 20.3291 78.7939 20.6453C79.5586 20.9615 80.2534 21.4254 80.8385 22.0105C81.4237 22.5957 81.8876 23.2905 82.2038 24.0552C82.52 24.8199 82.6822 25.6395 82.6811 26.467Z",
    fill: "url(#paint38_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M114.217 27.8981C114.217 29.8172 113.648 31.6932 112.581 33.2889C111.515 34.8846 110 36.1283 108.227 36.8627C106.454 37.5971 104.503 37.7892 102.621 37.4148C100.738 37.0404 99.0093 36.1163 97.6523 34.7593C96.2953 33.4023 95.3712 31.6733 94.9968 29.7911C94.6224 27.9088 94.8145 25.9578 95.5489 24.1848C96.2833 22.4118 97.527 20.8963 99.1227 19.8301C100.718 18.7639 102.594 18.1948 104.514 18.1948C107.087 18.1948 109.555 19.2171 111.375 21.0368C113.194 22.8565 114.217 25.3246 114.217 27.8981Z",
    fill: "url(#paint39_radial_1825_22010)"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M110.893 27.9063C110.891 29.1681 110.515 30.4011 109.813 31.4494C109.111 32.4976 108.113 33.3141 106.947 33.7955C105.781 34.2769 104.498 34.4016 103.26 34.1539C102.023 33.9061 100.887 33.2971 99.996 32.4037C99.1049 31.5103 98.4987 30.3728 98.2541 29.1349C98.0095 27.897 98.1374 26.6144 98.6218 25.4492C99.1062 24.2841 99.9251 23.2887 100.975 22.589C102.025 21.8893 103.259 21.5167 104.521 21.5183C105.359 21.5183 106.189 21.6837 106.963 22.0049C107.737 22.3261 108.44 22.7969 109.032 23.3903C109.624 23.9837 110.093 24.688 110.412 25.4629C110.732 26.2379 110.895 27.0682 110.893 27.9063Z",
    fill: "url(#paint40_radial_1825_22010)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M110.06 26.467C110.062 27.7148 109.693 28.935 109.001 29.9732C108.309 31.0115 107.324 31.8211 106.172 32.2998C105.02 32.7784 103.751 32.9044 102.527 32.662C101.303 32.4195 100.179 31.8195 99.296 30.9377C98.4131 30.056 97.8116 28.9322 97.5676 27.7085C97.3236 26.4848 97.448 25.2163 97.9251 24.0633C98.4023 22.9104 99.2107 21.9249 100.248 21.2315C101.285 20.5381 102.505 20.168 103.753 20.168C104.581 20.1669 105.401 20.3291 106.166 20.6451C106.931 20.9612 107.626 21.425 108.212 22.0101C108.798 22.5951 109.263 23.2898 109.58 24.0546C109.897 24.8194 110.06 25.6391 110.06 26.467Z",
    fill: "url(#paint41_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M141.588 27.8981C141.588 29.8172 141.019 31.6932 139.953 33.2889C138.886 34.8846 137.371 36.1283 135.598 36.8627C133.825 37.5971 131.874 37.7892 129.992 37.4148C128.109 37.0404 126.38 36.1163 125.023 34.7593C123.666 33.4023 122.742 31.6733 122.368 29.7911C121.993 27.9088 122.186 25.9578 122.92 24.1848C123.654 22.4118 124.898 20.8963 126.494 19.8301C128.089 18.7639 129.966 18.1948 131.885 18.1948C134.458 18.1948 136.926 19.2171 138.746 21.0368C140.566 22.8565 141.588 25.3246 141.588 27.8981Z",
    fill: "url(#paint42_radial_1825_22010)"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M138.272 27.9063C138.27 29.1677 137.895 30.4004 137.193 31.4485C136.491 32.4966 135.494 33.3131 134.328 33.7947C133.162 34.2764 131.879 34.4016 130.642 34.1545C129.405 33.9074 128.269 33.2991 127.378 32.4066C126.486 31.514 125.879 30.3772 125.634 29.1399C125.388 27.9025 125.515 26.6201 125.998 25.4548C126.481 24.2895 127.299 23.2936 128.348 22.593C129.397 21.8923 130.63 21.5183 131.892 21.5183C132.73 21.5183 133.561 21.6836 134.335 22.0047C135.11 22.3258 135.813 22.7965 136.406 23.3898C136.998 23.9831 137.468 24.6873 137.788 25.4623C138.109 26.2373 138.273 27.0678 138.272 27.9063Z",
    fill: "url(#paint43_radial_1825_22010)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M137.464 26.467C137.465 27.7151 137.096 28.9356 136.404 29.9741C135.712 31.0125 134.727 31.8222 133.574 32.3005C132.421 32.7789 131.152 32.9045 129.928 32.6614C128.704 32.4183 127.579 31.8174 126.697 30.9349C125.814 30.0523 125.213 28.9278 124.97 27.7035C124.727 26.4793 124.853 25.2105 125.331 24.0577C125.809 22.9049 126.619 21.92 127.657 21.2275C128.696 20.5351 129.916 20.1664 131.165 20.168C132.835 20.168 134.437 20.8316 135.619 22.0129C136.8 23.1942 137.464 24.7964 137.464 26.467Z",
    fill: "url(#paint44_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M168.999 27.8981C168.999 29.8172 168.43 31.6932 167.364 33.2889C166.297 34.8846 164.782 36.1283 163.009 36.8627C161.236 37.5971 159.285 37.7892 157.403 37.4148C155.521 37.0404 153.792 36.1163 152.435 34.7593C151.078 33.4023 150.153 31.6733 149.779 29.7911C149.405 27.9088 149.597 25.9578 150.331 24.1848C151.066 22.4118 152.309 20.8963 153.905 19.8301C155.501 18.7639 157.377 18.1948 159.296 18.1948C161.869 18.1948 164.337 19.2171 166.157 21.0368C167.977 22.8565 168.999 25.3246 168.999 27.8981Z",
    fill: "url(#paint45_radial_1825_22010)"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M165.643 27.9063C165.642 29.1681 165.266 30.4011 164.564 31.4494C163.861 32.4976 162.864 33.3141 161.697 33.7955C160.531 34.2769 159.248 34.4016 158.011 34.1539C156.774 33.9061 155.638 33.2971 154.746 32.4037C153.855 31.5103 153.249 30.3728 153.005 29.1349C152.76 27.897 152.888 26.6144 153.372 25.4492C153.857 24.2841 154.676 23.2887 155.726 22.589C156.776 21.8893 158.01 21.5167 159.272 21.5183C160.11 21.5183 160.94 21.6837 161.714 22.0049C162.488 22.3261 163.191 22.7969 163.783 23.3903C164.375 23.9837 164.844 24.688 165.163 25.4629C165.482 26.2379 165.645 27.0682 165.643 27.9063Z",
    fill: "url(#paint46_radial_1825_22010)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M164.802 26.467C164.804 27.7145 164.435 28.9343 163.744 29.9724C163.052 31.0105 162.068 31.8202 160.916 32.299C159.764 32.7779 158.496 32.9044 157.273 32.6626C156.049 32.4208 154.924 31.8216 154.041 30.9406C153.158 30.0597 152.556 28.9366 152.311 27.7135C152.066 26.4904 152.189 25.222 152.665 24.069C153.141 22.9159 153.948 21.9298 154.984 21.2354C156.021 20.5411 157.24 20.1696 158.487 20.168C159.316 20.1648 160.137 20.3254 160.904 20.6407C161.67 20.9559 162.367 21.4195 162.954 22.0048C163.541 22.5902 164.006 23.2857 164.323 24.0515C164.641 24.8173 164.803 25.6382 164.802 26.467Z",
    fill: "url(#paint47_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M196.338 27.8981C196.338 29.8172 195.769 31.6932 194.702 33.2889C193.636 34.8846 192.121 36.1283 190.348 36.8627C188.575 37.5971 186.624 37.7892 184.741 37.4148C182.859 37.0404 181.13 36.1163 179.773 34.7593C178.416 33.4023 177.492 31.6733 177.118 29.7911C176.743 27.9088 176.935 25.9578 177.67 24.1848C178.404 22.4118 179.648 20.8963 181.244 19.8301C182.839 18.7639 184.715 18.1948 186.634 18.1948C189.208 18.1948 191.676 19.2171 193.496 21.0368C195.315 22.8565 196.338 25.3246 196.338 27.8981Z",
    fill: "url(#paint48_radial_1825_22010)"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M193.015 27.9063C193.013 29.1681 192.637 30.4011 191.935 31.4494C191.233 32.4976 190.235 33.3141 189.069 33.7955C187.902 34.2769 186.619 34.4016 185.382 34.1539C184.145 33.9061 183.009 33.2971 182.118 32.4037C181.227 31.5103 180.621 30.3728 180.376 29.1349C180.131 27.897 180.259 26.6144 180.744 25.4492C181.228 24.2841 182.047 23.2887 183.097 22.589C184.147 21.8893 185.381 21.5167 186.643 21.5183C187.481 21.5183 188.311 21.6837 189.085 22.0049C189.859 22.3261 190.562 22.7969 191.154 23.3903C191.746 23.9837 192.215 24.688 192.534 25.4629C192.854 26.2379 193.017 27.0682 193.015 27.9063Z",
    fill: "url(#paint49_radial_1825_22010)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M192.174 26.467C192.175 27.7155 191.806 28.9363 191.114 29.9749C190.421 31.0135 189.435 31.8232 188.282 32.3013C187.129 32.7794 185.86 32.9045 184.635 32.6608C183.411 32.417 182.286 31.8154 181.404 30.932C180.522 30.0486 179.922 28.9233 179.679 27.6986C179.437 26.4738 179.564 25.2048 180.044 24.0521C180.523 22.8995 181.334 21.9151 182.374 21.2236C183.413 20.5322 184.634 20.1648 185.883 20.168C186.71 20.168 187.528 20.331 188.292 20.6476C189.056 20.9643 189.75 21.4284 190.334 22.0134C190.918 22.5984 191.382 23.2929 191.697 24.0571C192.013 24.8213 192.175 25.6402 192.174 26.467Z",
    fill: "url(#paint50_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M223.709 27.8981C223.709 29.8172 223.14 31.6932 222.074 33.2889C221.007 34.8846 219.492 36.1283 217.719 36.8627C215.946 37.5971 213.995 37.7892 212.113 37.4148C210.23 37.0404 208.502 36.1163 207.144 34.7593C205.787 33.4023 204.863 31.6733 204.489 29.7911C204.115 27.9088 204.307 25.9578 205.041 24.1848C205.776 22.4118 207.019 20.8963 208.615 19.8301C210.211 18.7639 212.087 18.1948 214.006 18.1948C216.579 18.1948 219.047 19.2171 220.867 21.0368C222.687 22.8565 223.709 25.3246 223.709 27.8981Z",
    fill: "url(#paint51_radial_1825_22010)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M220.394 27.9063C220.392 29.1677 220.017 30.4004 219.315 31.4485C218.613 32.4966 217.616 33.3131 216.45 33.7947C215.284 34.2764 214.002 34.4016 212.765 34.1545C211.527 33.9074 210.391 33.2991 209.5 32.4066C208.609 31.514 208.002 30.3772 207.756 29.1399C207.511 27.9025 207.638 26.6201 208.121 25.4548C208.604 24.2895 209.422 23.2936 210.471 22.593C211.52 21.8923 212.753 21.5183 214.014 21.5183C214.853 21.5183 215.683 21.6836 216.457 22.0047C217.232 22.3258 217.936 22.7965 218.528 23.3898C219.121 23.9831 219.591 24.6873 219.911 25.4623C220.231 26.2373 220.395 27.0678 220.394 27.9063Z",
    fill: "url(#paint52_radial_1825_22010)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M219.553 26.467C219.555 27.7151 219.186 28.9356 218.494 29.9741C217.801 31.0125 216.816 31.8222 215.663 32.3005C214.511 32.7789 213.242 32.9045 212.018 32.6614C210.793 32.4183 209.669 31.8174 208.786 30.9349C207.904 30.0523 207.303 28.9278 207.06 27.7035C206.817 26.4793 206.942 25.2105 207.421 24.0577C207.899 22.9049 208.709 21.92 209.747 21.2275C210.786 20.5351 212.006 20.1664 213.254 20.168C214.081 20.168 214.9 20.3309 215.665 20.6475C216.429 20.964 217.123 21.428 217.708 22.0129C218.293 22.5978 218.757 23.2922 219.074 24.0565C219.39 24.8207 219.553 25.6398 219.553 26.467Z",
    fill: "url(#paint53_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M251.089 27.8981C251.089 29.8172 250.52 31.6932 249.453 33.2889C248.387 34.8846 246.872 36.1283 245.099 36.8627C243.326 37.5971 241.375 37.7892 239.492 37.4148C237.61 37.0404 235.881 36.1163 234.524 34.7593C233.167 33.4023 232.243 31.6733 231.869 29.7911C231.494 27.9088 231.686 25.9578 232.421 24.1848C233.155 22.4118 234.399 20.8963 235.995 19.8301C237.59 18.7639 239.466 18.1948 241.385 18.1948C243.959 18.1948 246.427 19.2171 248.247 21.0368C250.066 22.8565 251.089 25.3246 251.089 27.8981Z",
    fill: "url(#paint54_radial_1825_22010)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M247.766 27.9063C247.764 29.1681 247.388 30.4011 246.686 31.4494C245.984 32.4976 244.986 33.3141 243.82 33.7955C242.653 34.2769 241.37 34.4016 240.133 34.1539C238.896 33.9061 237.76 33.2971 236.869 32.4037C235.978 31.5103 235.371 30.3728 235.127 29.1349C234.882 27.897 235.01 26.6144 235.495 25.4492C235.979 24.2841 236.798 23.2887 237.848 22.589C238.898 21.8893 240.132 21.5167 241.394 21.5183C242.232 21.5183 243.062 21.6837 243.836 22.0049C244.61 22.3261 245.313 22.7969 245.905 23.3903C246.497 23.9837 246.966 24.688 247.285 25.4629C247.604 26.2379 247.768 27.0682 247.766 27.9063Z",
    fill: "url(#paint55_radial_1825_22010)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M246.924 26.467C246.926 27.7151 246.557 28.9356 245.864 29.9741C245.172 31.0125 244.187 31.8222 243.034 32.3005C241.881 32.7789 240.613 32.9045 239.388 32.6614C238.164 32.4183 237.04 31.8174 236.157 30.9349C235.275 30.0523 234.674 28.9278 234.431 27.7035C234.188 26.4793 234.313 25.2105 234.791 24.0577C235.27 22.9049 236.079 21.92 237.118 21.2275C238.156 20.5351 239.377 20.1664 240.625 20.168C242.296 20.168 243.898 20.8316 245.079 22.0129C246.26 23.1942 246.924 24.7964 246.924 26.467Z",
    fill: "url(#paint56_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M278.46 27.8981C278.46 29.8172 277.891 31.6932 276.824 33.2889C275.758 34.8846 274.243 36.1283 272.47 36.8627C270.697 37.5971 268.746 37.7892 266.863 37.4148C264.981 37.0404 263.252 36.1163 261.895 34.7593C260.538 33.4023 259.614 31.6733 259.24 29.7911C258.865 27.9088 259.057 25.9578 259.792 24.1848C260.526 22.4118 261.77 20.8963 263.366 19.8301C264.961 18.7639 266.837 18.1948 268.756 18.1948C271.33 18.1948 273.798 19.2171 275.618 21.0368C277.437 22.8565 278.46 25.3246 278.46 27.8981Z",
    fill: "url(#paint57_radial_1825_22010)"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M275.136 27.9063C275.135 29.1681 274.759 30.4011 274.057 31.4494C273.354 32.4976 272.357 33.3141 271.191 33.7955C270.024 34.2769 268.741 34.4016 267.504 34.1539C266.267 33.9061 265.131 33.2971 264.24 32.4037C263.349 31.5103 262.742 30.3728 262.498 29.1349C262.253 27.897 262.381 26.6144 262.865 25.4492C263.35 24.2841 264.169 23.2887 265.219 22.589C266.269 21.8893 267.503 21.5167 268.765 21.5183C269.603 21.5183 270.433 21.6837 271.207 22.0049C271.981 22.3261 272.684 22.7969 273.276 23.3903C273.868 23.9837 274.337 24.688 274.656 25.4629C274.975 26.2379 275.139 27.0682 275.136 27.9063Z",
    fill: "url(#paint58_radial_1825_22010)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M274.304 26.467C274.305 27.7151 273.936 28.9356 273.244 29.9741C272.552 31.0125 271.567 31.8222 270.414 32.3005C269.261 32.7789 267.992 32.9045 266.768 32.6614C265.544 32.4183 264.419 31.8174 263.537 30.9349C262.654 30.0523 262.053 28.9278 261.81 27.7035C261.567 26.4793 261.693 25.2105 262.171 24.0577C262.649 22.9049 263.459 21.92 264.498 21.2275C265.536 20.5351 266.757 20.1664 268.005 20.168C269.675 20.168 271.277 20.8316 272.459 22.0129C273.64 23.1942 274.304 24.7964 274.304 26.467Z",
    fill: "url(#paint59_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M304.359 27.8981C304.359 29.8172 303.79 31.6932 302.724 33.2889C301.658 34.8846 300.142 36.1283 298.369 36.8627C296.596 37.5971 294.645 37.7892 292.763 37.4148C290.881 37.0404 289.152 36.1163 287.795 34.7593C286.438 33.4023 285.513 31.6733 285.139 29.7911C284.765 27.9088 284.957 25.9578 285.691 24.1848C286.426 22.4118 287.669 20.8963 289.265 19.8301C290.861 18.7639 292.737 18.1948 294.656 18.1948C297.229 18.1948 299.697 19.2171 301.517 21.0368C303.337 22.8565 304.359 25.3246 304.359 27.8981Z",
    fill: "url(#paint60_radial_1825_22010)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M301.036 27.9063C301.034 29.1681 300.658 30.4011 299.956 31.4494C299.254 32.4976 298.256 33.3141 297.09 33.7955C295.923 34.2769 294.64 34.4016 293.403 34.1539C292.166 33.9061 291.03 33.2971 290.139 32.4037C289.248 31.5103 288.641 30.3728 288.397 29.1349C288.152 27.897 288.28 26.6144 288.765 25.4492C289.249 24.2841 290.068 23.2887 291.118 22.589C292.168 21.8893 293.402 21.5167 294.664 21.5183C295.502 21.5183 296.332 21.6837 297.106 22.0049C297.88 22.3261 298.583 22.7969 299.175 23.3903C299.767 23.9837 300.236 24.688 300.555 25.4629C300.875 26.2379 301.038 27.0682 301.036 27.9063Z",
    fill: "url(#paint61_radial_1825_22010)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M300.195 26.467C300.197 27.7151 299.828 28.9356 299.135 29.9741C298.443 31.0125 297.458 31.8222 296.305 32.3005C295.152 32.7789 293.884 32.9045 292.659 32.6614C291.435 32.4183 290.311 31.8174 289.428 30.9349C288.546 30.0523 287.945 28.9278 287.702 27.7035C287.459 26.4793 287.584 25.2105 288.062 24.0577C288.541 22.9049 289.35 21.92 290.389 21.2275C291.427 20.5351 292.648 20.1664 293.896 20.168C294.723 20.1669 295.543 20.3291 296.308 20.6453C297.072 20.9615 297.767 21.4254 298.352 22.0105C298.938 22.5957 299.402 23.2905 299.718 24.0552C300.034 24.8199 300.196 25.6395 300.195 26.467Z",
    fill: "url(#paint62_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M331.73 27.8981C331.73 29.8172 331.161 31.6932 330.095 33.2889C329.029 34.8846 327.513 36.1283 325.74 36.8627C323.967 37.5971 322.016 37.7892 320.134 37.4148C318.252 37.0404 316.523 36.1163 315.166 34.7593C313.809 33.4023 312.885 31.6733 312.51 29.7911C312.136 27.9088 312.328 25.9578 313.062 24.1848C313.797 22.4118 315.04 20.8963 316.636 19.8301C318.232 18.7639 320.108 18.1948 322.027 18.1948C324.6 18.1948 327.068 19.2171 328.888 21.0368C330.708 22.8565 331.73 25.3246 331.73 27.8981Z",
    fill: "url(#paint63_radial_1825_22010)"
  }), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M328.407 27.9063C328.405 29.1681 328.03 30.4011 327.327 31.4494C326.625 32.4976 325.627 33.3141 324.461 33.7955C323.295 34.2769 322.012 34.4016 320.775 34.1539C319.537 33.9061 318.401 33.2971 317.51 32.4037C316.619 31.5103 316.013 30.3728 315.768 29.1349C315.524 27.897 315.652 26.6144 316.136 25.4492C316.62 24.2841 317.439 23.2887 318.489 22.589C319.539 21.8893 320.773 21.5167 322.035 21.5183C322.873 21.5183 323.703 21.6837 324.477 22.0049C325.251 22.3261 325.955 22.7969 326.546 23.3903C327.138 23.9837 327.607 24.688 327.927 25.4629C328.246 26.2379 328.409 27.0682 328.407 27.9063Z",
    fill: "url(#paint64_radial_1825_22010)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M327.574 26.467C327.576 27.7148 327.207 28.935 326.515 29.9732C325.823 31.0115 324.839 31.8211 323.686 32.2998C322.534 32.7784 321.266 32.9044 320.042 32.662C318.818 32.4195 317.693 31.8195 316.81 30.9377C315.927 30.056 315.326 28.9322 315.082 27.7085C314.838 26.4848 314.962 25.2163 315.439 24.0633C315.916 22.9104 316.725 21.9249 317.762 21.2315C318.8 20.5381 320.019 20.168 321.267 20.168C322.095 20.1669 322.915 20.3291 323.68 20.6451C324.445 20.9612 325.141 21.425 325.726 22.0101C326.312 22.5951 326.777 23.2898 327.094 24.0546C327.411 24.8194 327.574 25.6391 327.574 26.467Z",
    fill: "url(#paint65_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M359.102 27.8981C359.102 29.8172 358.532 31.6932 357.466 33.2889C356.4 34.8846 354.885 36.1283 353.112 36.8627C351.339 37.5971 349.388 37.7892 347.505 37.4148C345.623 37.0404 343.894 36.1163 342.537 34.7593C341.18 33.4023 340.256 31.6733 339.882 29.7911C339.507 27.9088 339.699 25.9578 340.434 24.1848C341.168 22.4118 342.412 20.8963 344.007 19.8301C345.603 18.7639 347.479 18.1948 349.398 18.1948C351.972 18.1948 354.44 19.2171 356.26 21.0368C358.079 22.8565 359.102 25.3246 359.102 27.8981Z",
    fill: "url(#paint66_radial_1825_22010)"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M355.787 27.9063C355.785 29.1677 355.409 30.4004 354.707 31.4485C354.005 32.4966 353.008 33.3131 351.843 33.7947C350.677 34.2764 349.394 34.4016 348.157 34.1545C346.92 33.9074 345.784 33.2991 344.893 32.4066C344.001 31.514 343.394 30.3772 343.149 29.1399C342.903 27.9025 343.03 26.6201 343.513 25.4548C343.996 24.2895 344.814 23.2936 345.863 22.593C346.912 21.8923 348.145 21.5183 349.407 21.5183C350.245 21.5183 351.075 21.6836 351.85 22.0047C352.625 22.3258 353.328 22.7965 353.921 23.3898C354.513 23.9831 354.983 24.6873 355.303 25.4623C355.623 26.2373 355.788 27.0678 355.787 27.9063Z",
    fill: "url(#paint67_radial_1825_22010)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M354.978 26.467C354.979 27.7151 354.611 28.9356 353.918 29.9741C353.226 31.0125 352.241 31.8222 351.088 32.3005C349.935 32.7789 348.666 32.9045 347.442 32.6614C346.218 32.4183 345.093 31.8174 344.211 30.9349C343.328 30.0523 342.727 28.9278 342.484 27.7035C342.241 26.4793 342.367 25.2105 342.845 24.0577C343.324 22.9049 344.133 21.92 345.172 21.2275C346.21 20.5351 347.431 20.1664 348.679 20.168C350.349 20.168 351.951 20.8316 353.133 22.0129C354.314 23.1942 354.978 24.7964 354.978 26.467Z",
    fill: "url(#paint68_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M386.513 27.8981C386.513 29.8172 385.944 31.6932 384.878 33.2889C383.812 34.8846 382.296 36.1283 380.523 36.8627C378.75 37.5971 376.799 37.7892 374.917 37.4148C373.035 37.0404 371.306 36.1163 369.949 34.7593C368.592 33.4023 367.668 31.6733 367.293 29.7911C366.919 27.9088 367.111 25.9578 367.846 24.1848C368.58 22.4118 369.824 20.8963 371.419 19.8301C373.015 18.7639 374.891 18.1948 376.81 18.1948C379.384 18.1948 381.852 19.2171 383.671 21.0368C385.491 22.8565 386.513 25.3246 386.513 27.8981Z",
    fill: "url(#paint69_radial_1825_22010)"
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M383.158 27.9063C383.156 29.1681 382.78 30.4011 382.078 31.4494C381.376 32.4976 380.378 33.3141 379.212 33.7955C378.045 34.2769 376.763 34.4016 375.525 34.1539C374.288 33.9061 373.152 33.2971 372.261 32.4037C371.37 31.5103 370.764 30.3728 370.519 29.1349C370.274 27.897 370.402 26.6144 370.887 25.4492C371.371 24.2841 372.19 23.2887 373.24 22.589C374.29 21.8893 375.524 21.5167 376.786 21.5183C377.624 21.5183 378.454 21.6837 379.228 22.0049C380.002 22.3261 380.705 22.7969 381.297 23.3903C381.889 23.9837 382.358 24.688 382.677 25.4629C382.997 26.2379 383.16 27.0682 383.158 27.9063Z",
    fill: "url(#paint70_radial_1825_22010)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M382.317 26.467C382.318 27.7145 381.95 28.9343 381.258 29.9724C380.567 31.0105 379.583 31.8202 378.431 32.299C377.279 32.7779 376.011 32.9044 374.787 32.6626C373.563 32.4208 372.439 31.8216 371.556 30.9406C370.672 30.0597 370.07 28.9366 369.825 27.7135C369.58 26.4904 369.704 25.222 370.18 24.069C370.656 22.9159 371.463 21.9298 372.499 21.2354C373.535 20.5411 374.754 20.1696 376.002 20.168C376.83 20.1648 377.652 20.3254 378.418 20.6407C379.185 20.9559 379.882 21.4195 380.469 22.0048C381.055 22.5902 381.521 23.2857 381.838 24.0515C382.155 24.8173 382.318 25.6382 382.317 26.467Z",
    fill: "url(#paint71_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M413.852 27.8981C413.852 29.8172 413.283 31.6932 412.217 33.2889C411.151 34.8846 409.635 36.1283 407.862 36.8627C406.089 37.5971 404.138 37.7892 402.256 37.4148C400.374 37.0404 398.645 36.1163 397.288 34.7593C395.931 33.4023 395.006 31.6733 394.632 29.7911C394.258 27.9088 394.45 25.9578 395.184 24.1848C395.919 22.4118 397.162 20.8963 398.758 19.8301C400.354 18.7639 402.23 18.1948 404.149 18.1948C406.722 18.1948 409.19 19.2171 411.01 21.0368C412.83 22.8565 413.852 25.3246 413.852 27.8981Z",
    fill: "url(#paint72_radial_1825_22010)"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M410.529 27.9063C410.527 29.1681 410.151 30.4011 409.449 31.4494C408.747 32.4976 407.749 33.3141 406.583 33.7955C405.417 34.2769 404.134 34.4016 402.896 34.1539C401.659 33.9061 400.523 33.2971 399.632 32.4037C398.741 31.5103 398.135 30.3728 397.89 29.1349C397.645 27.897 397.773 26.6144 398.258 25.4492C398.742 24.2841 399.561 23.2887 400.611 22.589C401.661 21.8893 402.895 21.5167 404.157 21.5183C404.995 21.5183 405.825 21.6837 406.599 22.0049C407.373 22.3261 408.076 22.7969 408.668 23.3903C409.26 23.9837 409.729 24.688 410.048 25.4629C410.368 26.2379 410.531 27.0682 410.529 27.9063Z",
    fill: "url(#paint73_radial_1825_22010)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M409.688 26.467C409.689 27.7155 409.32 28.9363 408.628 29.9749C407.935 31.0135 406.949 31.8232 405.796 32.3013C404.643 32.7794 403.374 32.9045 402.149 32.6608C400.925 32.417 399.8 31.8154 398.918 30.932C398.036 30.0486 397.435 28.9233 397.193 27.6986C396.951 26.4738 397.078 25.2048 397.557 24.0521C398.037 22.8995 398.848 21.9151 399.887 21.2236C400.927 20.5322 402.148 20.1648 403.397 20.168C404.224 20.168 405.042 20.331 405.806 20.6476C406.57 20.9643 407.264 21.4284 407.848 22.0134C408.432 22.5984 408.895 23.2929 409.211 24.0571C409.527 24.8213 409.689 25.6402 409.688 26.467Z",
    fill: "url(#paint74_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M441.223 27.8981C441.223 29.8172 440.654 31.6932 439.588 33.2889C438.522 34.8846 437.006 36.1283 435.233 36.8627C433.46 37.5971 431.509 37.7892 429.627 37.4148C427.745 37.0404 426.016 36.1163 424.659 34.7593C423.302 33.4023 422.378 31.6733 422.003 29.7911C421.629 27.9088 421.821 25.9578 422.556 24.1848C423.29 22.4118 424.534 20.8963 426.129 19.8301C427.725 18.7639 429.601 18.1948 431.52 18.1948C434.094 18.1948 436.562 19.2171 438.381 21.0368C440.201 22.8565 441.223 25.3246 441.223 27.8981Z",
    fill: "url(#paint75_radial_1825_22010)"
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M437.908 27.9063C437.907 29.1677 437.531 30.4004 436.829 31.4485C436.127 32.4966 435.13 33.3131 433.964 33.7947C432.798 34.2764 431.516 34.4016 430.279 34.1545C429.042 33.9074 427.906 33.2991 427.014 32.4066C426.123 31.514 425.516 30.3772 425.27 29.1399C425.025 27.9025 425.152 26.6201 425.635 25.4548C426.118 24.2895 426.936 23.2936 427.985 22.593C429.034 21.8923 430.267 21.5183 431.528 21.5183C432.367 21.5183 433.197 21.6836 433.972 22.0047C434.746 22.3258 435.45 22.7965 436.042 23.3898C436.635 23.9831 437.105 24.6873 437.425 25.4623C437.745 26.2373 437.909 27.0678 437.908 27.9063Z",
    fill: "url(#paint76_radial_1825_22010)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M437.067 26.467C437.069 27.7151 436.7 28.9356 436.008 29.9741C435.315 31.0125 434.33 31.8222 433.178 32.3005C432.025 32.7789 430.756 32.9045 429.532 32.6614C428.308 32.4183 427.183 31.8174 426.3 30.9349C425.418 30.0523 424.817 28.9278 424.574 27.7035C424.331 26.4793 424.456 25.2105 424.935 24.0577C425.413 22.9049 426.223 21.92 427.261 21.2275C428.3 20.5351 429.52 20.1664 430.768 20.168C432.439 20.168 434.041 20.8316 435.222 22.0129C436.404 23.1942 437.067 24.7964 437.067 26.467Z",
    fill: "url(#paint77_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M468.603 27.8981C468.603 29.8172 468.034 31.6932 466.967 33.2889C465.901 34.8846 464.386 36.1283 462.613 36.8627C460.84 37.5971 458.889 37.7892 457.007 37.4148C455.124 37.0404 453.395 36.1163 452.038 34.7593C450.681 33.4023 449.757 31.6733 449.383 29.7911C449.008 27.9088 449.201 25.9578 449.935 24.1848C450.669 22.4118 451.913 20.8963 453.509 19.8301C455.104 18.7639 456.98 18.1948 458.9 18.1948C461.473 18.1948 463.941 19.2171 465.761 21.0368C467.58 22.8565 468.603 25.3246 468.603 27.8981Z",
    fill: "url(#paint78_radial_1825_22010)"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M465.279 27.9063C465.277 29.1681 464.902 30.4011 464.199 31.4494C463.497 32.4976 462.5 33.3141 461.333 33.7955C460.167 34.2769 458.884 34.4016 457.647 34.1539C456.409 33.9061 455.273 33.2971 454.382 32.4037C453.491 31.5103 452.885 30.3728 452.64 29.1349C452.396 27.897 452.524 26.6144 453.008 25.4492C453.492 24.2841 454.311 23.2887 455.361 22.589C456.411 21.8893 457.645 21.5167 458.907 21.5183C459.745 21.5183 460.575 21.6837 461.349 22.0049C462.123 22.3261 462.827 22.7969 463.418 23.3903C464.01 23.9837 464.479 24.688 464.799 25.4629C465.118 26.2379 465.281 27.0682 465.279 27.9063Z",
    fill: "url(#paint79_radial_1825_22010)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M464.438 26.467C464.44 27.7151 464.071 28.9356 463.379 29.9741C462.686 31.0125 461.702 31.8222 460.549 32.3005C459.396 32.7789 458.127 32.9045 456.903 32.6614C455.679 32.4183 454.554 31.8174 453.672 30.9349C452.789 30.0523 452.188 28.9278 451.945 27.7035C451.702 26.4793 451.828 25.2105 452.306 24.0577C452.784 22.9049 453.594 21.92 454.632 21.2275C455.671 20.5351 456.891 20.1664 458.139 20.168C459.81 20.168 461.412 20.8316 462.594 22.0129C463.775 23.1942 464.438 24.7964 464.438 26.467Z",
    fill: "url(#paint80_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M495.974 27.8981C495.974 29.8172 495.405 31.6932 494.339 33.2889C493.272 34.8846 491.757 36.1283 489.984 36.8627C488.211 37.5971 486.26 37.7892 484.378 37.4148C482.495 37.0404 480.766 36.1163 479.409 34.7593C478.052 33.4023 477.128 31.6733 476.754 29.7911C476.379 27.9088 476.572 25.9578 477.306 24.1848C478.04 22.4118 479.284 20.8963 480.88 19.8301C482.475 18.7639 484.351 18.1948 486.271 18.1948C488.844 18.1948 491.312 19.2171 493.132 21.0368C494.952 22.8565 495.974 25.3246 495.974 27.8981Z",
    fill: "url(#paint81_radial_1825_22010)"
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M492.65 27.9063C492.649 29.1681 492.273 30.4011 491.571 31.4494C490.868 32.4976 489.871 33.3141 488.705 33.7955C487.538 34.2769 486.255 34.4016 485.018 34.1539C483.781 33.9061 482.645 33.2971 481.754 32.4037C480.862 31.5103 480.256 30.3728 480.012 29.1349C479.767 27.897 479.895 26.6144 480.379 25.4492C480.864 24.2841 481.683 23.2887 482.733 22.589C483.783 21.8893 485.017 21.5167 486.279 21.5183C487.117 21.5183 487.947 21.6837 488.721 22.0049C489.495 22.3261 490.198 22.7969 490.79 23.3903C491.382 23.9837 491.851 24.688 492.17 25.4629C492.489 26.2379 492.653 27.0682 492.65 27.9063Z",
    fill: "url(#paint82_radial_1825_22010)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M491.818 26.467C491.819 27.7151 491.45 28.9356 490.758 29.9741C490.066 31.0125 489.081 31.8222 487.928 32.3005C486.775 32.7789 485.506 32.9045 484.282 32.6614C483.058 32.4183 481.933 31.8174 481.051 30.9349C480.168 30.0523 479.567 28.9278 479.324 27.7035C479.081 26.4793 479.207 25.2105 479.685 24.0577C480.163 22.9049 480.973 21.92 482.011 21.2275C483.05 20.5351 484.27 20.1664 485.519 20.168C487.189 20.168 488.791 20.8316 489.973 22.0129C491.154 23.1942 491.818 24.7964 491.818 26.467Z",
    fill: "url(#paint83_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M523.167 27.8981C523.167 29.8172 522.598 31.6932 521.532 33.2889C520.466 34.8846 518.95 36.1283 517.177 36.8627C515.404 37.5971 513.453 37.7892 511.571 37.4148C509.689 37.0404 507.96 36.1163 506.603 34.7593C505.246 33.4023 504.322 31.6733 503.947 29.7911C503.573 27.9088 503.765 25.9578 504.499 24.1848C505.234 22.4118 506.477 20.8963 508.073 19.8301C509.669 18.7639 511.545 18.1948 513.464 18.1948C516.037 18.1948 518.505 19.2171 520.325 21.0368C522.145 22.8565 523.167 25.3246 523.167 27.8981Z",
    fill: "url(#paint84_radial_1825_22010)"
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M519.811 27.9063C519.81 29.1681 519.434 30.4011 518.732 31.4494C518.029 32.4976 517.032 33.3141 515.866 33.7955C514.699 34.2769 513.416 34.4016 512.179 34.1539C510.942 33.9061 509.806 33.2971 508.915 32.4037C508.024 31.5103 507.417 30.3728 507.173 29.1349C506.928 27.897 507.056 26.6144 507.541 25.4492C508.025 24.2841 508.844 23.2887 509.894 22.589C510.944 21.8893 512.178 21.5167 513.44 21.5183C514.278 21.5183 515.108 21.6837 515.882 22.0049C516.656 22.3261 517.359 22.7969 517.951 23.3903C518.543 23.9837 519.012 24.688 519.331 25.4629C519.65 26.2379 519.814 27.0682 519.811 27.9063Z",
    fill: "url(#paint85_radial_1825_22010)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M518.97 26.467C518.972 27.7145 518.603 28.9343 517.912 29.9724C517.22 31.0105 516.236 31.8202 515.084 32.299C513.932 32.7779 512.664 32.9044 511.441 32.6626C510.217 32.4208 509.092 31.8216 508.209 30.9406C507.326 30.0597 506.724 28.9366 506.479 27.7135C506.234 26.4904 506.357 25.222 506.833 24.069C507.309 22.9159 508.116 21.9298 509.152 21.2354C510.189 20.5411 511.408 20.1696 512.655 20.168C513.484 20.1648 514.305 20.3254 515.072 20.6407C515.838 20.9559 516.535 21.4195 517.122 22.0048C517.709 22.5902 518.174 23.2857 518.491 24.0515C518.809 24.8173 518.971 25.6382 518.97 26.467Z",
    fill: "url(#paint86_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M550.506 27.8981C550.506 29.8172 549.937 31.6932 548.87 33.2889C547.804 34.8846 546.289 36.1283 544.516 36.8627C542.743 37.5971 540.792 37.7892 538.909 37.4148C537.027 37.0404 535.298 36.1163 533.941 34.7593C532.584 33.4023 531.66 31.6733 531.286 29.7911C530.911 27.9088 531.103 25.9578 531.838 24.1848C532.572 22.4118 533.816 20.8963 535.411 19.8301C537.007 18.7639 538.883 18.1948 540.802 18.1948C543.376 18.1948 545.844 19.2171 547.664 21.0368C549.483 22.8565 550.506 25.3246 550.506 27.8981Z",
    fill: "url(#paint87_radial_1825_22010)"
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M547.183 27.9063C547.181 29.1681 546.805 30.4011 546.103 31.4494C545.401 32.4976 544.403 33.3141 543.237 33.7955C542.07 34.2769 540.787 34.4016 539.55 34.1539C538.313 33.9061 537.177 33.2971 536.286 32.4037C535.395 31.5103 534.788 30.3728 534.544 29.1349C534.299 27.897 534.427 26.6144 534.912 25.4492C535.396 24.2841 536.215 23.2887 537.265 22.589C538.315 21.8893 539.549 21.5167 540.811 21.5183C541.649 21.5183 542.479 21.6837 543.253 22.0049C544.027 22.3261 544.73 22.7969 545.322 23.3903C545.914 23.9837 546.383 24.688 546.702 25.4629C547.021 26.2379 547.185 27.0682 547.183 27.9063Z",
    fill: "url(#paint88_radial_1825_22010)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M546.342 26.467C546.343 27.7155 545.974 28.9363 545.282 29.9749C544.589 31.0135 543.603 31.8232 542.45 32.3013C541.297 32.7794 540.028 32.9045 538.803 32.6608C537.579 32.417 536.454 31.8154 535.572 30.932C534.69 30.0486 534.09 28.9233 533.847 27.6986C533.605 26.4738 533.732 25.2048 534.212 24.0521C534.691 22.8995 535.502 21.9151 536.542 21.2236C537.581 20.5322 538.802 20.1648 540.051 20.168C540.878 20.168 541.696 20.331 542.46 20.6476C543.224 20.9643 543.918 21.4284 544.502 22.0134C545.086 22.5984 545.55 23.2929 545.865 24.0571C546.181 24.8213 546.343 25.6402 546.342 26.467Z",
    fill: "url(#paint89_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M577.877 27.8981C577.877 29.8172 577.308 31.6932 576.242 33.2889C575.176 34.8846 573.66 36.1283 571.887 36.8627C570.114 37.5971 568.163 37.7892 566.281 37.4148C564.399 37.0404 562.67 36.1163 561.313 34.7593C559.956 33.4023 559.032 31.6733 558.657 29.7911C558.283 27.9088 558.475 25.9578 559.209 24.1848C559.944 22.4118 561.187 20.8963 562.783 19.8301C564.379 18.7639 566.255 18.1948 568.174 18.1948C570.747 18.1948 573.215 19.2171 575.035 21.0368C576.855 22.8565 577.877 25.3246 577.877 27.8981Z",
    fill: "url(#paint90_radial_1825_22010)"
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M574.562 27.9063C574.561 29.1677 574.185 30.4004 573.483 31.4485C572.781 32.4966 571.784 33.3131 570.618 33.7947C569.452 34.2764 568.17 34.4016 566.933 34.1545C565.696 33.9074 564.56 33.2991 563.668 32.4066C562.777 31.514 562.17 30.3772 561.925 29.1399C561.679 27.9025 561.806 26.6201 562.289 25.4548C562.772 24.2895 563.59 23.2936 564.639 22.593C565.688 21.8923 566.921 21.5183 568.182 21.5183C569.021 21.5183 569.851 21.6836 570.626 22.0047C571.4 22.3258 572.104 22.7965 572.696 23.3898C573.289 23.9831 573.759 24.6873 574.079 25.4623C574.399 26.2373 574.563 27.0678 574.562 27.9063Z",
    fill: "url(#paint91_radial_1825_22010)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M573.721 26.467C573.723 27.7151 573.354 28.9356 572.662 29.9741C571.969 31.0125 570.984 31.8222 569.831 32.3005C568.679 32.7789 567.41 32.9045 566.186 32.6614C564.961 32.4183 563.837 31.8174 562.954 30.9349C562.072 30.0523 561.471 28.9278 561.228 27.7035C560.985 26.4793 561.11 25.2105 561.589 24.0577C562.067 22.9049 562.877 21.92 563.915 21.2275C564.953 20.5351 566.174 20.1664 567.422 20.168C569.093 20.168 570.695 20.8316 571.876 22.0129C573.057 23.1942 573.721 24.7964 573.721 26.467Z",
    fill: "url(#paint92_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M605.257 27.8981C605.257 29.8172 604.687 31.6932 603.621 33.2889C602.555 34.8846 601.04 36.1283 599.267 36.8627C597.494 37.5971 595.543 37.7892 593.66 37.4148C591.778 37.0404 590.049 36.1163 588.692 34.7593C587.335 33.4023 586.411 31.6733 586.037 29.7911C585.662 27.9088 585.854 25.9578 586.589 24.1848C587.323 22.4118 588.567 20.8963 590.163 19.8301C591.758 18.7639 593.634 18.1948 595.553 18.1948C598.127 18.1948 600.595 19.2171 602.415 21.0368C604.234 22.8565 605.257 25.3246 605.257 27.8981Z",
    fill: "url(#paint93_radial_1825_22010)"
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M601.933 27.9063C601.931 29.1681 601.556 30.4011 600.853 31.4494C600.151 32.4976 599.153 33.3141 597.987 33.7955C596.821 34.2769 595.538 34.4016 594.3 34.1539C593.063 33.9061 591.927 33.2971 591.036 32.4037C590.145 31.5103 589.539 30.3728 589.294 29.1349C589.05 27.897 589.177 26.6144 589.662 25.4492C590.146 24.2841 590.965 23.2887 592.015 22.589C593.065 21.8893 594.299 21.5167 595.561 21.5183C596.399 21.5183 597.229 21.6837 598.003 22.0049C598.777 22.3261 599.48 22.7969 600.072 23.3903C600.664 23.9837 601.133 24.688 601.452 25.4629C601.772 26.2379 601.935 27.0682 601.933 27.9063Z",
    fill: "url(#paint94_radial_1825_22010)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M601.092 26.467C601.094 27.7151 600.725 28.9356 600.033 29.9741C599.34 31.0125 598.355 31.8222 597.203 32.3005C596.05 32.7789 594.781 32.9045 593.557 32.6614C592.332 32.4183 591.208 31.8174 590.325 30.9349C589.443 30.0523 588.842 28.9278 588.599 27.7035C588.356 26.4793 588.481 25.2105 588.96 24.0577C589.438 22.9049 590.248 21.92 591.286 21.2275C592.325 20.5351 593.545 20.1664 594.793 20.168C596.464 20.168 598.066 20.8316 599.247 22.0129C600.429 23.1942 601.092 24.7964 601.092 26.467Z",
    fill: "url(#paint95_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M632.628 27.8981C632.628 29.8172 632.059 31.6932 630.993 33.2889C629.926 34.8846 628.411 36.1283 626.638 36.8627C624.865 37.5971 622.914 37.7892 621.032 37.4148C619.149 37.0404 617.42 36.1163 616.063 34.7593C614.706 33.4023 613.782 31.6733 613.408 29.7911C613.033 27.9088 613.226 25.9578 613.96 24.1848C614.694 22.4118 615.938 20.8963 617.534 19.8301C619.13 18.7639 621.006 18.1948 622.925 18.1948C625.498 18.1948 627.966 19.2171 629.786 21.0368C631.606 22.8565 632.628 25.3246 632.628 27.8981Z",
    fill: "url(#paint96_radial_1825_22010)"
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M629.304 27.9063C629.302 29.1681 628.927 30.4011 628.224 31.4494C627.522 32.4976 626.524 33.3141 625.358 33.7955C624.192 34.2769 622.909 34.4016 621.671 34.1539C620.434 33.9061 619.298 33.2971 618.407 32.4037C617.516 31.5103 616.91 30.3728 616.665 29.1349C616.421 27.897 616.549 26.6144 617.033 25.4492C617.517 24.2841 618.336 23.2887 619.386 22.589C620.436 21.8893 621.67 21.5167 622.932 21.5183C623.77 21.5183 624.6 21.6837 625.374 22.0049C626.148 22.3261 626.852 22.7969 627.443 23.3903C628.035 23.9837 628.504 24.688 628.824 25.4629C629.143 26.2379 629.306 27.0682 629.304 27.9063Z",
    fill: "url(#paint97_radial_1825_22010)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M628.472 26.467C628.473 27.7151 628.104 28.9356 627.412 29.9741C626.72 31.0125 625.735 31.8222 624.582 32.3005C623.429 32.7789 622.16 32.9045 620.936 32.6614C619.712 32.4183 618.587 31.8174 617.705 30.9349C616.822 30.0523 616.221 28.9278 615.978 27.7035C615.735 26.4793 615.861 25.2105 616.339 24.0577C616.817 22.9049 617.627 21.92 618.666 21.2275C619.704 20.5351 620.924 20.1664 622.173 20.168C623.843 20.168 625.445 20.8316 626.627 22.0129C627.808 23.1942 628.472 24.7964 628.472 26.467Z",
    fill: "url(#paint98_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M62.289 162.203C62.289 164.122 61.72 165.998 60.6538 167.594C59.5875 169.19 58.0721 170.433 56.2991 171.168C54.526 171.902 52.575 172.094 50.6928 171.72C48.8106 171.346 47.0816 170.421 45.7246 169.064C44.3676 167.707 43.4434 165.978 43.069 164.096C42.6946 162.214 42.8868 160.263 43.6212 158.49C44.3556 156.717 45.5993 155.201 47.195 154.135C48.7907 153.069 50.6667 152.5 52.5858 152.5C55.1592 152.5 57.6273 153.522 59.447 155.342C61.2667 157.162 62.289 159.63 62.289 162.203Z",
    fill: "url(#paint99_radial_1825_22010)"
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9744 162.203C58.9744 163.465 58.6002 164.698 57.8991 165.748C57.1981 166.797 56.2017 167.614 55.036 168.097C53.8702 168.58 52.5874 168.707 51.3498 168.46C50.1123 168.214 48.9755 167.607 48.0832 166.714C47.191 165.822 46.5833 164.685 46.3372 163.448C46.091 162.21 46.2174 160.927 46.7003 159.762C47.1831 158.596 48.0009 157.599 49.05 156.898C50.0992 156.197 51.3327 155.823 52.5945 155.823C54.2865 155.823 55.9093 156.495 57.1057 157.692C58.3022 158.888 58.9744 160.511 58.9744 162.203Z",
    fill: "url(#paint100_linear_1825_22010)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M58.133 160.764C58.1346 162.012 57.7659 163.232 57.0734 164.271C56.381 165.309 55.396 166.119 54.2432 166.597C53.0904 167.076 51.8216 167.201 50.5974 166.958C49.3732 166.715 48.2487 166.114 47.3661 165.232C46.4836 164.349 45.8827 163.225 45.6396 162C45.3965 160.776 45.5221 159.507 46.0005 158.355C46.4788 157.202 47.2885 156.217 48.3269 155.524C49.3654 154.832 50.5858 154.463 51.834 154.465C53.5046 154.465 55.1067 155.128 56.288 156.31C57.4693 157.491 58.133 159.093 58.133 160.764Z",
    fill: "url(#paint101_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M89.6955 162.203C89.6955 164.122 89.1265 165.998 88.0602 167.594C86.994 169.19 85.4786 170.433 83.7056 171.168C81.9325 171.902 79.9815 172.094 78.0993 171.72C76.2171 171.346 74.4881 170.421 73.1311 169.064C71.7741 167.707 70.8499 165.978 70.4755 164.096C70.1011 162.214 70.2933 160.263 71.0277 158.49C71.7621 156.717 73.0058 155.201 74.6015 154.135C76.1972 153.069 78.0732 152.5 79.9923 152.5C82.5657 152.5 85.0338 153.522 86.8535 155.342C88.6732 157.162 89.6955 159.63 89.6955 162.203Z",
    fill: "url(#paint102_radial_1825_22010)"
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3809 162.203C86.3809 163.465 86.0067 164.698 85.3056 165.748C84.6046 166.797 83.6082 167.614 82.4425 168.097C81.2767 168.58 79.9939 168.707 78.7563 168.46C77.5188 168.214 76.382 167.607 75.4897 166.714C74.5975 165.822 73.9898 164.685 73.7437 163.448C73.4975 162.21 73.6239 160.927 74.1068 159.762C74.5896 158.596 75.4074 157.599 76.4565 156.898C77.5057 156.197 78.7391 155.823 80.001 155.823C81.693 155.823 83.3158 156.495 84.5122 157.692C85.7087 158.888 86.3809 160.511 86.3809 162.203Z",
    fill: "url(#paint103_linear_1825_22010)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5395 160.764C85.5411 162.012 85.1724 163.232 84.4799 164.271C83.7875 165.309 82.8025 166.119 81.6497 166.597C80.4969 167.076 79.2281 167.201 78.0039 166.958C76.7797 166.715 75.6552 166.114 74.7726 165.232C73.8901 164.349 73.2892 163.225 73.0461 162C72.803 160.776 72.9286 159.507 73.407 158.355C73.8853 157.202 74.695 156.217 75.7334 155.524C76.7719 154.832 77.9923 154.463 79.2405 154.465C80.9111 154.465 82.5132 155.128 83.6945 156.31C84.8758 157.491 85.5395 159.093 85.5395 160.764Z",
    fill: "url(#paint104_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M117.102 162.203C117.102 164.122 116.533 165.998 115.467 167.594C114.401 169.19 112.885 170.433 111.112 171.168C109.339 171.902 107.388 172.094 105.506 171.72C103.624 171.346 101.895 170.421 100.538 169.064C99.1806 167.707 98.2564 165.978 97.882 164.096C97.5076 162.214 97.6998 160.263 98.4342 158.49C99.1686 156.717 100.412 155.201 102.008 154.135C103.604 153.069 105.48 152.5 107.399 152.5C109.972 152.5 112.44 153.522 114.26 155.342C116.08 157.162 117.102 159.63 117.102 162.203Z",
    fill: "url(#paint105_radial_1825_22010)"
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M113.787 162.203C113.787 163.465 113.413 164.698 112.712 165.748C112.011 166.797 111.015 167.614 109.849 168.097C108.683 168.58 107.4 168.707 106.163 168.46C104.925 168.214 103.788 167.607 102.896 166.714C102.004 165.822 101.396 164.685 101.15 163.448C100.904 162.21 101.03 160.927 101.513 159.762C101.996 158.596 102.814 157.599 103.863 156.898C104.912 156.197 106.146 155.823 107.407 155.823C109.1 155.823 110.722 156.495 111.919 157.692C113.115 158.888 113.787 160.511 113.787 162.203Z",
    fill: "url(#paint106_linear_1825_22010)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M112.946 160.764C112.948 162.012 112.579 163.232 111.886 164.271C111.194 165.309 110.209 166.119 109.056 166.597C107.903 167.076 106.635 167.201 105.41 166.958C104.186 166.715 103.062 166.114 102.179 165.232C101.297 164.349 100.696 163.225 100.453 162C100.209 160.776 100.335 159.507 100.813 158.355C101.292 157.202 102.101 156.217 103.14 155.524C104.178 154.832 105.399 154.463 106.647 154.465C108.318 154.465 109.92 155.128 111.101 156.31C112.282 157.491 112.946 159.093 112.946 160.764Z",
    fill: "url(#paint107_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M144.509 162.203C144.509 164.122 143.939 165.998 142.873 167.594C141.807 169.19 140.292 170.433 138.519 171.168C136.746 171.902 134.795 172.094 132.912 171.72C131.03 171.346 129.301 170.421 127.944 169.064C126.587 167.707 125.663 165.978 125.289 164.096C124.914 162.214 125.106 160.263 125.841 158.49C126.575 156.717 127.819 155.201 129.414 154.135C131.01 153.069 132.886 152.5 134.805 152.5C137.379 152.5 139.847 153.522 141.667 155.342C143.486 157.162 144.509 159.63 144.509 162.203Z",
    fill: "url(#paint108_radial_1825_22010)"
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M141.194 162.203C141.194 163.465 140.82 164.698 140.119 165.748C139.418 166.797 138.421 167.614 137.255 168.097C136.09 168.58 134.807 168.707 133.569 168.46C132.332 168.214 131.195 167.607 130.303 166.714C129.41 165.822 128.803 164.685 128.557 163.448C128.31 162.21 128.437 160.927 128.92 159.762C129.403 158.596 130.22 157.599 131.27 156.898C132.319 156.197 133.552 155.823 134.814 155.823C136.506 155.823 138.129 156.495 139.325 157.692C140.522 158.888 141.194 160.511 141.194 162.203Z",
    fill: "url(#paint109_linear_1825_22010)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M140.352 160.764C140.354 162.012 139.985 163.232 139.293 164.271C138.601 165.309 137.616 166.119 136.463 166.597C135.31 167.076 134.041 167.201 132.817 166.958C131.593 166.715 130.468 166.114 129.586 165.232C128.703 164.349 128.102 163.225 127.859 162C127.616 160.776 127.742 159.507 128.22 158.355C128.698 157.202 129.508 156.217 130.546 155.524C131.585 154.832 132.805 154.463 134.053 154.465C135.724 154.465 137.326 155.128 138.508 156.31C139.689 157.491 140.352 159.093 140.352 160.764Z",
    fill: "url(#paint110_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M171.915 162.203C171.915 164.122 171.346 165.998 170.279 167.594C169.213 169.19 167.698 170.433 165.925 171.168C164.152 171.902 162.201 172.094 160.319 171.72C158.436 171.346 156.707 170.421 155.35 169.064C153.993 167.707 153.069 165.978 152.695 164.096C152.32 162.214 152.513 160.263 153.247 158.49C153.981 156.717 155.225 155.201 156.821 154.135C158.416 153.069 160.292 152.5 162.212 152.5C164.785 152.5 167.253 153.522 169.073 155.342C170.892 157.162 171.915 159.63 171.915 162.203Z",
    fill: "url(#paint111_radial_1825_22010)"
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M168.6 162.203C168.6 163.465 168.226 164.698 167.525 165.748C166.824 166.797 165.827 167.614 164.662 168.097C163.496 168.58 162.213 168.707 160.976 168.46C159.738 168.214 158.601 167.607 157.709 166.714C156.817 165.822 156.209 164.685 155.963 163.448C155.717 162.21 155.843 160.927 156.326 159.762C156.809 158.596 157.627 157.599 158.676 156.898C159.725 156.197 160.958 155.823 162.22 155.823C163.912 155.823 165.535 156.495 166.731 157.692C167.928 158.888 168.6 160.511 168.6 162.203Z",
    fill: "url(#paint112_linear_1825_22010)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M167.759 160.764C167.76 162.012 167.392 163.232 166.699 164.271C166.007 165.309 165.022 166.119 163.869 166.597C162.716 167.076 161.447 167.201 160.223 166.958C158.999 166.715 157.874 166.114 156.992 165.232C156.109 164.349 155.508 163.225 155.265 162C155.022 160.776 155.148 159.507 155.626 158.355C156.105 157.202 156.914 156.217 157.953 155.524C158.991 154.832 160.212 154.463 161.46 154.465C163.13 154.465 164.732 155.128 165.914 156.31C167.095 157.491 167.759 159.093 167.759 160.764Z",
    fill: "url(#paint113_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M199.321 162.203C199.321 164.122 198.752 165.998 197.686 167.594C196.62 169.19 195.104 170.433 193.331 171.168C191.558 171.902 189.607 172.094 187.725 171.72C185.843 171.346 184.114 170.421 182.757 169.064C181.4 167.707 180.476 165.978 180.101 164.096C179.727 162.214 179.919 160.263 180.653 158.49C181.388 156.717 182.632 155.201 184.227 154.135C185.823 153.069 187.699 152.5 189.618 152.5C192.191 152.5 194.66 153.522 196.479 155.342C198.299 157.162 199.321 159.63 199.321 162.203Z",
    fill: "url(#paint114_radial_1825_22010)"
  }), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M196.007 162.203C196.007 163.465 195.632 164.698 194.931 165.748C194.23 166.797 193.234 167.614 192.068 168.097C190.902 168.58 189.62 168.707 188.382 168.46C187.144 168.214 186.008 167.607 185.115 166.714C184.223 165.822 183.616 164.685 183.369 163.448C183.123 162.21 183.25 160.927 183.732 159.762C184.215 158.596 185.033 157.599 186.082 156.898C187.131 156.197 188.365 155.823 189.627 155.823C191.319 155.823 192.942 156.495 194.138 157.692C195.334 158.888 196.007 160.511 196.007 162.203Z",
    fill: "url(#paint115_linear_1825_22010)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M195.165 160.764C195.167 162.012 194.798 163.232 194.106 164.271C193.413 165.309 192.428 166.119 191.275 166.597C190.123 167.076 188.854 167.201 187.63 166.958C186.405 166.715 185.281 166.114 184.398 165.232C183.516 164.349 182.915 163.225 182.672 162C182.429 160.776 182.554 159.507 183.033 158.355C183.511 157.202 184.321 156.217 185.359 155.524C186.398 154.832 187.618 154.463 188.866 154.465C190.537 154.465 192.139 155.128 193.32 156.31C194.502 157.491 195.165 159.093 195.165 160.764Z",
    fill: "url(#paint116_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M226.728 162.203C226.728 164.122 226.159 165.998 225.092 167.594C224.026 169.19 222.511 170.433 220.738 171.168C218.965 171.902 217.014 172.094 215.132 171.72C213.249 171.346 211.52 170.421 210.163 169.064C208.806 167.707 207.882 165.978 207.508 164.096C207.133 162.214 207.325 160.263 208.06 158.49C208.794 156.717 210.038 155.201 211.634 154.135C213.229 153.069 215.105 152.5 217.025 152.5C219.598 152.5 222.066 153.522 223.886 155.342C225.705 157.162 226.728 159.63 226.728 162.203Z",
    fill: "url(#paint117_radial_1825_22010)"
  }), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M223.413 162.203C223.413 163.465 223.039 164.698 222.338 165.748C221.637 166.797 220.64 167.614 219.475 168.097C218.309 168.58 217.026 168.707 215.789 168.46C214.551 168.214 213.414 167.607 212.522 166.714C211.63 165.822 211.022 164.685 210.776 163.448C210.53 162.21 210.656 160.927 211.139 159.762C211.622 158.596 212.44 157.599 213.489 156.898C214.538 156.197 215.771 155.823 217.033 155.823C218.725 155.823 220.348 156.495 221.544 157.692C222.741 158.888 223.413 160.511 223.413 162.203Z",
    fill: "url(#paint118_linear_1825_22010)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M222.572 160.764C222.573 162.012 222.205 163.232 221.512 164.271C220.82 165.309 219.835 166.119 218.682 166.597C217.529 167.076 216.26 167.201 215.036 166.958C213.812 166.715 212.687 166.114 211.805 165.232C210.922 164.349 210.321 163.225 210.078 162C209.835 160.776 209.961 159.507 210.439 158.355C210.918 157.202 211.727 156.217 212.766 155.524C213.804 154.832 215.025 154.463 216.273 154.465C217.943 154.465 219.545 155.128 220.727 156.31C221.908 157.491 222.572 159.093 222.572 160.764Z",
    fill: "url(#paint119_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M254.134 162.203C254.134 164.122 253.565 165.998 252.499 167.594C251.433 169.19 249.917 170.433 248.144 171.168C246.371 171.902 244.42 172.094 242.538 171.72C240.656 171.346 238.927 170.421 237.57 169.064C236.213 167.707 235.289 165.978 234.914 164.096C234.54 162.214 234.732 160.263 235.466 158.49C236.201 156.717 237.445 155.201 239.04 154.135C240.636 153.069 242.512 152.5 244.431 152.5C247.004 152.5 249.473 153.522 251.292 155.342C253.112 157.162 254.134 159.63 254.134 162.203Z",
    fill: "url(#paint120_radial_1825_22010)"
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M250.82 162.203C250.82 163.465 250.445 164.698 249.744 165.748C249.043 166.797 248.047 167.614 246.881 168.097C245.715 168.58 244.433 168.707 243.195 168.46C241.957 168.214 240.821 167.607 239.928 166.714C239.036 165.822 238.429 164.685 238.182 163.448C237.936 162.21 238.063 160.927 238.545 159.762C239.028 158.596 239.846 157.599 240.895 156.898C241.944 156.197 243.178 155.823 244.44 155.823C246.132 155.823 247.755 156.495 248.951 157.692C250.147 158.888 250.82 160.511 250.82 162.203Z",
    fill: "url(#paint121_linear_1825_22010)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M249.978 160.764C249.98 162.012 249.611 163.232 248.919 164.271C248.226 165.309 247.241 166.119 246.088 166.597C244.936 167.076 243.667 167.201 242.443 166.958C241.218 166.715 240.094 166.114 239.211 165.232C238.329 164.349 237.728 163.225 237.485 162C237.242 160.776 237.367 159.507 237.846 158.355C238.324 157.202 239.134 156.217 240.172 155.524C241.211 154.832 242.431 154.463 243.679 154.465C245.35 154.465 246.952 155.128 248.133 156.31C249.315 157.491 249.978 159.093 249.978 160.764Z",
    fill: "url(#paint122_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M281.541 162.203C281.541 164.122 280.972 165.998 279.905 167.594C278.839 169.19 277.324 170.433 275.551 171.168C273.778 171.902 271.827 172.094 269.945 171.72C268.062 171.346 266.333 170.421 264.976 169.064C263.619 167.707 262.695 165.978 262.321 164.096C261.946 162.214 262.138 160.263 262.873 158.49C263.607 156.717 264.851 155.201 266.447 154.135C268.042 153.069 269.918 152.5 271.838 152.5C274.411 152.5 276.879 153.522 278.699 155.342C280.518 157.162 281.541 159.63 281.541 162.203Z",
    fill: "url(#paint123_radial_1825_22010)"
  }), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M278.226 162.203C278.226 163.465 277.852 164.698 277.151 165.748C276.45 166.797 275.453 167.614 274.288 168.097C273.122 168.58 271.839 168.707 270.602 168.46C269.364 168.214 268.227 167.607 267.335 166.714C266.443 165.822 265.835 164.685 265.589 163.448C265.343 162.21 265.469 160.927 265.952 159.762C266.435 158.596 267.253 157.599 268.302 156.898C269.351 156.197 270.584 155.823 271.846 155.823C273.538 155.823 275.161 156.495 276.357 157.692C277.554 158.888 278.226 160.511 278.226 162.203Z",
    fill: "url(#paint124_linear_1825_22010)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M277.385 160.764C277.386 162.012 277.018 163.232 276.325 164.271C275.633 165.309 274.648 166.119 273.495 166.597C272.342 167.076 271.073 167.201 269.849 166.958C268.625 166.715 267.5 166.114 266.618 165.232C265.735 164.349 265.134 163.225 264.891 162C264.648 160.776 264.774 159.507 265.252 158.355C265.731 157.202 266.54 156.217 267.579 155.524C268.617 154.832 269.838 154.463 271.086 154.465C272.756 154.465 274.358 155.128 275.54 156.31C276.721 157.491 277.385 159.093 277.385 160.764Z",
    fill: "url(#paint125_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M308.947 162.203C308.947 164.122 308.378 165.998 307.312 167.594C306.246 169.19 304.73 170.433 302.957 171.168C301.184 171.902 299.233 172.094 297.351 171.72C295.469 171.346 293.74 170.421 292.383 169.064C291.026 167.707 290.101 165.978 289.727 164.096C289.353 162.214 289.545 160.263 290.279 158.49C291.014 156.717 292.257 155.201 293.853 154.135C295.449 153.069 297.325 152.5 299.244 152.5C301.817 152.5 304.285 153.522 306.105 155.342C307.925 157.162 308.947 159.63 308.947 162.203Z",
    fill: "url(#paint126_radial_1825_22010)"
  }), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M305.632 162.203C305.632 163.465 305.258 164.698 304.557 165.748C303.856 166.797 302.86 167.614 301.694 168.097C300.528 168.58 299.245 168.707 298.008 168.46C296.77 168.214 295.633 167.607 294.741 166.714C293.849 165.822 293.241 164.685 292.995 163.448C292.749 162.21 292.875 160.927 293.358 159.762C293.841 158.596 294.659 157.599 295.708 156.898C296.757 156.197 297.991 155.823 299.252 155.823C300.944 155.823 302.567 156.495 303.764 157.692C304.96 158.888 305.632 160.511 305.632 162.203Z",
    fill: "url(#paint127_linear_1825_22010)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M304.791 160.764C304.793 162.012 304.424 163.232 303.731 164.271C303.039 165.309 302.054 166.119 300.901 166.597C299.748 167.076 298.48 167.201 297.255 166.958C296.031 166.715 294.907 166.114 294.024 165.232C293.142 164.349 292.541 163.225 292.298 162C292.054 160.776 292.18 159.507 292.658 158.355C293.137 157.202 293.946 156.217 294.985 155.524C296.023 154.832 297.244 154.463 298.492 154.465C300.163 154.465 301.765 155.128 302.946 156.31C304.127 157.491 304.791 159.093 304.791 160.764Z",
    fill: "url(#paint128_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M336.353 162.203C336.353 164.122 335.784 165.998 334.718 167.594C333.652 169.19 332.137 170.433 330.364 171.168C328.59 171.902 326.639 172.094 324.757 171.72C322.875 171.346 321.146 170.421 319.789 169.064C318.432 167.707 317.508 165.978 317.133 164.096C316.759 162.214 316.951 160.263 317.686 158.49C318.42 156.717 319.664 155.201 321.259 154.135C322.855 153.069 324.731 152.5 326.65 152.5C329.224 152.5 331.692 153.522 333.511 155.342C335.331 157.162 336.353 159.63 336.353 162.203Z",
    fill: "url(#paint129_radial_1825_22010)"
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M333.039 162.203C333.039 163.465 332.665 164.698 331.964 165.748C331.263 166.797 330.266 167.614 329.1 168.097C327.935 168.58 326.652 168.707 325.414 168.46C324.177 168.214 323.04 167.607 322.148 166.714C321.255 165.822 320.648 164.685 320.402 163.448C320.155 162.21 320.282 160.927 320.765 159.762C321.248 158.596 322.065 157.599 323.114 156.898C324.164 156.197 325.397 155.823 326.659 155.823C328.351 155.823 329.974 156.495 331.17 157.692C332.367 158.888 333.039 160.511 333.039 162.203Z",
    fill: "url(#paint130_linear_1825_22010)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M332.197 160.764C332.199 162.012 331.83 163.232 331.138 164.271C330.445 165.309 329.46 166.119 328.308 166.597C327.155 167.076 325.886 167.201 324.662 166.958C323.438 166.715 322.313 166.114 321.431 165.232C320.548 164.349 319.947 163.225 319.704 162C319.461 160.776 319.587 159.507 320.065 158.355C320.543 157.202 321.353 156.217 322.391 155.524C323.43 154.832 324.65 154.463 325.898 154.465C327.569 154.465 329.171 155.128 330.352 156.31C331.534 157.491 332.197 159.093 332.197 160.764Z",
    fill: "url(#paint131_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M363.76 162.203C363.76 164.122 363.191 165.998 362.125 167.594C361.058 169.19 359.543 170.433 357.77 171.168C355.997 171.902 354.046 172.094 352.164 171.72C350.282 171.346 348.553 170.421 347.196 169.064C345.839 167.707 344.914 165.978 344.54 164.096C344.166 162.214 344.358 160.263 345.092 158.49C345.827 156.717 347.07 155.201 348.666 154.135C350.262 153.069 352.138 152.5 354.057 152.5C356.63 152.5 359.098 153.522 360.918 155.342C362.738 157.162 363.76 159.63 363.76 162.203Z",
    fill: "url(#paint132_radial_1825_22010)"
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M360.445 162.203C360.445 163.465 360.071 164.698 359.37 165.748C358.669 166.797 357.673 167.614 356.507 168.097C355.341 168.58 354.058 168.707 352.821 168.46C351.583 168.214 350.446 167.607 349.554 166.714C348.662 165.822 348.054 164.685 347.808 163.448C347.562 162.21 347.688 160.927 348.171 159.762C348.654 158.596 349.472 157.599 350.521 156.898C351.57 156.197 352.804 155.823 354.065 155.823C355.757 155.823 357.38 156.495 358.577 157.692C359.773 158.888 360.445 160.511 360.445 162.203Z",
    fill: "url(#paint133_linear_1825_22010)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M359.604 160.764C359.606 162.012 359.237 163.232 358.544 164.271C357.852 165.309 356.867 166.119 355.714 166.597C354.561 167.076 353.293 167.201 352.068 166.958C350.844 166.715 349.72 166.114 348.837 165.232C347.955 164.349 347.354 163.225 347.111 162C346.867 160.776 346.993 159.507 347.471 158.355C347.95 157.202 348.759 156.217 349.798 155.524C350.836 154.832 352.057 154.463 353.305 154.465C354.976 154.465 356.578 155.128 357.759 156.31C358.94 157.491 359.604 159.093 359.604 160.764Z",
    fill: "url(#paint134_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M391.166 162.203C391.166 164.122 390.597 165.998 389.531 167.594C388.465 169.19 386.95 170.433 385.177 171.168C383.403 171.902 381.452 172.094 379.57 171.72C377.688 171.346 375.959 170.421 374.602 169.064C373.245 167.707 372.321 165.978 371.946 164.096C371.572 162.214 371.764 160.263 372.499 158.49C373.233 156.717 374.477 155.201 376.072 154.135C377.668 153.069 379.544 152.5 381.463 152.5C384.037 152.5 386.505 153.522 388.324 155.342C390.144 157.162 391.166 159.63 391.166 162.203Z",
    fill: "url(#paint135_radial_1825_22010)"
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M387.852 162.203C387.852 163.465 387.478 164.698 386.777 165.748C386.076 166.797 385.079 167.614 383.913 168.097C382.748 168.58 381.465 168.707 380.227 168.46C378.99 168.214 377.853 167.607 376.961 166.714C376.068 165.822 375.461 164.685 375.215 163.448C374.968 162.21 375.095 160.927 375.578 159.762C376.061 158.596 376.878 157.599 377.927 156.898C378.977 156.197 380.21 155.823 381.472 155.823C383.164 155.823 384.787 156.495 385.983 157.692C387.18 158.888 387.852 160.511 387.852 162.203Z",
    fill: "url(#paint136_linear_1825_22010)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M387.01 160.764C387.012 162.012 386.643 163.232 385.951 164.271C385.258 165.309 384.273 166.119 383.121 166.597C381.968 167.076 380.699 167.201 379.475 166.958C378.251 166.715 377.126 166.114 376.244 165.232C375.361 164.349 374.76 163.225 374.517 162C374.274 160.776 374.4 159.507 374.878 158.355C375.356 157.202 376.166 156.217 377.204 155.524C378.243 154.832 379.463 154.463 380.711 154.465C382.382 154.465 383.984 155.128 385.165 156.31C386.347 157.491 387.01 159.093 387.01 160.764Z",
    fill: "url(#paint137_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M418.573 162.203C418.573 164.122 418.004 165.998 416.938 167.594C415.871 169.19 414.356 170.433 412.583 171.168C410.81 171.902 408.859 172.094 406.977 171.72C405.094 171.346 403.366 170.421 402.009 169.064C400.652 167.707 399.727 165.978 399.353 164.096C398.979 162.214 399.171 160.263 399.905 158.49C400.64 156.717 401.883 155.201 403.479 154.135C405.075 153.069 406.951 152.5 408.87 152.5C411.443 152.5 413.911 153.522 415.731 155.342C417.551 157.162 418.573 159.63 418.573 162.203Z",
    fill: "url(#paint138_radial_1825_22010)"
  }), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M415.258 162.203C415.258 163.465 414.884 164.698 414.183 165.748C413.482 166.797 412.486 167.614 411.32 168.097C410.154 168.58 408.871 168.707 407.634 168.46C406.396 168.214 405.259 167.607 404.367 166.714C403.475 165.822 402.867 164.685 402.621 163.448C402.375 162.21 402.501 160.927 402.984 159.762C403.467 158.596 404.285 157.599 405.334 156.898C406.383 156.197 407.617 155.823 408.878 155.823C410.57 155.823 412.193 156.495 413.39 157.692C414.586 158.888 415.258 160.511 415.258 162.203Z",
    fill: "url(#paint139_linear_1825_22010)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M414.417 160.764C414.419 162.012 414.05 163.232 413.357 164.271C412.665 165.309 411.68 166.119 410.527 166.597C409.374 167.076 408.106 167.201 406.881 166.958C405.657 166.715 404.533 166.114 403.65 165.232C402.767 164.349 402.167 163.225 401.924 162C401.68 160.776 401.806 159.507 402.284 158.355C402.763 157.202 403.572 156.217 404.611 155.524C405.649 154.832 406.87 154.463 408.118 154.465C409.788 154.465 411.391 155.128 412.572 156.31C413.753 157.491 414.417 159.093 414.417 160.764Z",
    fill: "url(#paint140_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M445.979 162.203C445.979 164.122 445.41 165.998 444.344 167.594C443.278 169.19 441.763 170.433 439.99 171.168C438.216 171.902 436.265 172.094 434.383 171.72C432.501 171.346 430.772 170.421 429.415 169.064C428.058 167.707 427.134 165.978 426.759 164.096C426.385 162.214 426.577 160.263 427.312 158.49C428.046 156.717 429.29 155.201 430.885 154.135C432.481 153.069 434.357 152.5 436.276 152.5C438.85 152.5 441.318 153.522 443.137 155.342C444.957 157.162 445.979 159.63 445.979 162.203Z",
    fill: "url(#paint141_radial_1825_22010)"
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M442.665 162.203C442.665 163.465 442.291 164.698 441.59 165.748C440.889 166.797 439.892 167.614 438.726 168.097C437.561 168.58 436.278 168.707 435.04 168.46C433.803 168.214 432.666 167.607 431.774 166.714C430.881 165.822 430.274 164.685 430.028 163.448C429.781 162.21 429.908 160.927 430.391 159.762C430.874 158.596 431.691 157.599 432.74 156.898C433.79 156.197 435.023 155.823 436.285 155.823C437.977 155.823 439.6 156.495 440.796 157.692C441.993 158.888 442.665 160.511 442.665 162.203Z",
    fill: "url(#paint142_linear_1825_22010)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M441.823 160.764C441.825 162.012 441.456 163.232 440.764 164.271C440.071 165.309 439.086 166.119 437.934 166.597C436.781 167.076 435.512 167.201 434.288 166.958C433.064 166.715 431.939 166.114 431.057 165.232C430.174 164.349 429.573 163.225 429.33 162C429.087 160.776 429.213 159.507 429.691 158.355C430.169 157.202 430.979 156.217 432.017 155.524C433.056 154.832 434.276 154.463 435.524 154.465C437.195 154.465 438.797 155.128 439.978 156.31C441.16 157.491 441.823 159.093 441.823 160.764Z",
    fill: "url(#paint143_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M473.386 162.203C473.386 164.122 472.817 165.998 471.751 167.594C470.684 169.19 469.169 170.433 467.396 171.168C465.623 171.902 463.672 172.094 461.79 171.72C459.907 171.346 458.179 170.421 456.822 169.064C455.465 167.707 454.54 165.978 454.166 164.096C453.792 162.214 453.984 160.263 454.718 158.49C455.453 156.717 456.696 155.201 458.292 154.135C459.888 153.069 461.764 152.5 463.683 152.5C466.256 152.5 468.724 153.522 470.544 155.342C472.364 157.162 473.386 159.63 473.386 162.203Z",
    fill: "url(#paint144_radial_1825_22010)"
  }), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M470.071 162.203C470.071 163.465 469.697 164.698 468.996 165.748C468.295 166.797 467.299 167.614 466.133 168.097C464.967 168.58 463.684 168.707 462.447 168.46C461.209 168.214 460.072 167.607 459.18 166.714C458.288 165.822 457.68 164.685 457.434 163.448C457.188 162.21 457.314 160.927 457.797 159.762C458.28 158.596 459.098 157.599 460.147 156.898C461.196 156.197 462.43 155.823 463.691 155.823C465.383 155.823 467.006 156.495 468.203 157.692C469.399 158.888 470.071 160.511 470.071 162.203Z",
    fill: "url(#paint145_linear_1825_22010)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M469.23 160.764C469.232 162.012 468.863 163.232 468.17 164.271C467.478 165.309 466.493 166.119 465.34 166.597C464.187 167.076 462.919 167.201 461.694 166.958C460.47 166.715 459.346 166.114 458.463 165.232C457.58 164.349 456.98 163.225 456.737 162C456.493 160.776 456.619 159.507 457.097 158.355C457.576 157.202 458.385 156.217 459.424 155.524C460.462 154.832 461.683 154.463 462.931 154.465C464.601 154.465 466.204 155.128 467.385 156.31C468.566 157.491 469.23 159.093 469.23 160.764Z",
    fill: "url(#paint146_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M500.792 162.203C500.792 164.122 500.223 165.998 499.157 167.594C498.091 169.19 496.575 170.433 494.802 171.168C493.029 171.902 491.078 172.094 489.196 171.72C487.314 171.346 485.585 170.421 484.228 169.064C482.871 167.707 481.947 165.978 481.572 164.096C481.198 162.214 481.39 160.263 482.124 158.49C482.859 156.717 484.102 155.201 485.698 154.135C487.294 153.069 489.17 152.5 491.089 152.5C493.662 152.5 496.13 153.522 497.95 155.342C499.77 157.162 500.792 159.63 500.792 162.203Z",
    fill: "url(#paint147_radial_1825_22010)"
  }), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M497.478 162.203C497.478 163.465 497.103 164.698 496.402 165.748C495.701 166.797 494.705 167.614 493.539 168.097C492.373 168.58 491.091 168.707 489.853 168.46C488.615 168.214 487.479 167.607 486.586 166.714C485.694 165.822 485.087 164.685 484.84 163.448C484.594 162.21 484.721 160.927 485.203 159.762C485.686 158.596 486.504 157.599 487.553 156.898C488.602 156.197 489.836 155.823 491.098 155.823C492.79 155.823 494.412 156.495 495.609 157.692C496.805 158.888 497.478 160.511 497.478 162.203Z",
    fill: "url(#paint148_linear_1825_22010)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M496.636 160.764C496.638 162.012 496.269 163.232 495.577 164.271C494.884 165.309 493.899 166.119 492.746 166.597C491.594 167.076 490.325 167.201 489.101 166.958C487.876 166.715 486.752 166.114 485.869 165.232C484.987 164.349 484.386 163.225 484.143 162C483.9 160.776 484.025 159.507 484.504 158.355C484.982 157.202 485.792 156.217 486.83 155.524C487.869 154.832 489.089 154.463 490.337 154.465C492.008 154.465 493.61 155.128 494.791 156.31C495.973 157.491 496.636 159.093 496.636 160.764Z",
    fill: "url(#paint149_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M528.199 162.203C528.199 164.122 527.63 165.998 526.563 167.594C525.497 169.19 523.982 170.433 522.209 171.168C520.436 171.902 518.485 172.094 516.602 171.72C514.72 171.346 512.991 170.421 511.634 169.064C510.277 167.707 509.353 165.978 508.979 164.096C508.604 162.214 508.796 160.263 509.531 158.49C510.265 156.717 511.509 155.201 513.105 154.135C514.7 153.069 516.576 152.5 518.495 152.5C521.069 152.5 523.537 153.522 525.357 155.342C527.176 157.162 528.199 159.63 528.199 162.203Z",
    fill: "url(#paint150_radial_1825_22010)"
  }), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M524.884 162.203C524.884 163.465 524.51 164.698 523.809 165.748C523.108 166.797 522.111 167.614 520.946 168.097C519.78 168.58 518.497 168.707 517.26 168.46C516.022 168.214 514.885 167.607 513.993 166.714C513.101 165.822 512.493 164.685 512.247 163.448C512.001 162.21 512.127 160.927 512.61 159.762C513.093 158.596 513.911 157.599 514.96 156.898C516.009 156.197 517.242 155.823 518.504 155.823C520.196 155.823 521.819 156.495 523.015 157.692C524.212 158.888 524.884 160.511 524.884 162.203Z",
    fill: "url(#paint151_linear_1825_22010)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M524.043 160.764C524.044 162.012 523.676 163.232 522.983 164.271C522.291 165.309 521.306 166.119 520.153 166.597C519 167.076 517.731 167.201 516.507 166.958C515.283 166.715 514.158 166.114 513.276 165.232C512.393 164.349 511.792 163.225 511.549 162C511.306 160.776 511.432 159.507 511.91 158.355C512.389 157.202 513.198 156.217 514.237 155.524C515.275 154.832 516.496 154.463 517.744 154.465C519.414 154.465 521.016 155.128 522.198 156.31C523.379 157.491 524.043 159.093 524.043 160.764Z",
    fill: "url(#paint152_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M555.605 162.203C555.605 164.122 555.036 165.998 553.97 167.594C552.904 169.19 551.388 170.433 549.615 171.168C547.842 171.902 545.891 172.094 544.009 171.72C542.127 171.346 540.398 170.421 539.041 169.064C537.684 167.707 536.76 165.978 536.385 164.096C536.011 162.214 536.203 160.263 536.937 158.49C537.672 156.717 538.915 155.201 540.511 154.135C542.107 153.069 543.983 152.5 545.902 152.5C548.475 152.5 550.943 153.522 552.763 155.342C554.583 157.162 555.605 159.63 555.605 162.203Z",
    fill: "url(#paint153_radial_1825_22010)"
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M552.291 162.203C552.291 163.465 551.916 164.698 551.215 165.748C550.514 166.797 549.518 167.614 548.352 168.097C547.186 168.58 545.904 168.707 544.666 168.46C543.428 168.214 542.292 167.607 541.399 166.714C540.507 165.822 539.9 164.685 539.653 163.448C539.407 162.21 539.534 160.927 540.016 159.762C540.499 158.596 541.317 157.599 542.366 156.898C543.415 156.197 544.649 155.823 545.911 155.823C547.603 155.823 549.225 156.495 550.422 157.692C551.618 158.888 552.291 160.511 552.291 162.203Z",
    fill: "url(#paint154_linear_1825_22010)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M551.449 160.764C551.451 162.012 551.082 163.232 550.39 164.271C549.697 165.309 548.712 166.119 547.559 166.597C546.407 167.076 545.138 167.201 543.914 166.958C542.689 166.715 541.565 166.114 540.682 165.232C539.8 164.349 539.199 163.225 538.956 162C538.713 160.776 538.838 159.507 539.317 158.355C539.795 157.202 540.605 156.217 541.643 155.524C542.682 154.832 543.902 154.463 545.15 154.465C546.821 154.465 548.423 155.128 549.604 156.31C550.785 157.491 551.449 159.093 551.449 160.764Z",
    fill: "url(#paint155_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M583.012 162.203C583.012 164.122 582.443 165.998 581.376 167.594C580.31 169.19 578.795 170.433 577.022 171.168C575.249 171.902 573.298 172.094 571.415 171.72C569.533 171.346 567.804 170.421 566.447 169.064C565.09 167.707 564.166 165.978 563.792 164.096C563.417 162.214 563.609 160.263 564.344 158.49C565.078 156.717 566.322 155.201 567.918 154.135C569.513 153.069 571.389 152.5 573.308 152.5C575.882 152.5 578.35 153.522 580.17 155.342C581.989 157.162 583.012 159.63 583.012 162.203Z",
    fill: "url(#paint156_radial_1825_22010)"
  }), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M579.697 162.203C579.697 163.465 579.323 164.698 578.622 165.748C577.921 166.797 576.924 167.614 575.759 168.097C574.593 168.58 573.31 168.707 572.072 168.46C570.835 168.214 569.698 167.607 568.806 166.714C567.914 165.822 567.306 164.685 567.06 163.448C566.814 162.21 566.94 160.927 567.423 159.762C567.906 158.596 568.724 157.599 569.773 156.898C570.822 156.197 572.055 155.823 573.317 155.823C575.009 155.823 576.632 156.495 577.828 157.692C579.025 158.888 579.697 160.511 579.697 162.203Z",
    fill: "url(#paint157_linear_1825_22010)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M578.856 160.764C578.857 162.012 578.489 163.232 577.796 164.271C577.104 165.309 576.119 166.119 574.966 166.597C573.813 167.076 572.544 167.201 571.32 166.958C570.096 166.715 568.971 166.114 568.089 165.232C567.206 164.349 566.605 163.225 566.362 162C566.119 160.776 566.245 159.507 566.723 158.355C567.201 157.202 568.011 156.217 569.05 155.524C570.088 154.832 571.309 154.463 572.557 154.465C574.227 154.465 575.829 155.128 577.011 156.31C578.192 157.491 578.856 159.093 578.856 160.764Z",
    fill: "url(#paint158_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M610.418 162.203C610.418 164.122 609.849 165.998 608.783 167.594C607.717 169.19 606.201 170.433 604.428 171.168C602.655 171.902 600.704 172.094 598.822 171.72C596.94 171.346 595.211 170.421 593.854 169.064C592.497 167.707 591.573 165.978 591.198 164.096C590.824 162.214 591.016 160.263 591.75 158.49C592.485 156.717 593.728 155.201 595.324 154.135C596.92 153.069 598.796 152.5 600.715 152.5C603.288 152.5 605.756 153.522 607.576 155.342C609.396 157.162 610.418 159.63 610.418 162.203Z",
    fill: "url(#paint159_radial_1825_22010)"
  }), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M607.104 162.203C607.104 163.465 606.729 164.698 606.028 165.748C605.327 166.797 604.331 167.614 603.165 168.097C601.999 168.58 600.717 168.707 599.479 168.46C598.241 168.214 597.105 167.607 596.212 166.714C595.32 165.822 594.712 164.685 594.466 163.448C594.22 162.21 594.347 160.927 594.829 159.762C595.312 158.596 596.13 157.599 597.179 156.898C598.228 156.197 599.462 155.823 600.724 155.823C602.416 155.823 604.038 156.495 605.235 157.692C606.431 158.888 607.104 160.511 607.104 162.203Z",
    fill: "url(#paint160_linear_1825_22010)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M606.262 160.764C606.264 162.012 605.895 163.232 605.203 164.271C604.51 165.309 603.525 166.119 602.372 166.597C601.22 167.076 599.951 167.201 598.727 166.958C597.502 166.715 596.378 166.114 595.495 165.232C594.613 164.349 594.012 163.225 593.769 162C593.526 160.776 593.651 159.507 594.13 158.355C594.608 157.202 595.418 156.217 596.456 155.524C597.495 154.832 598.715 154.463 599.963 154.465C601.634 154.465 603.236 155.128 604.417 156.31C605.598 157.491 606.262 159.093 606.262 160.764Z",
    fill: "url(#paint161_radial_1825_22010)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M637.824 162.203C637.824 164.122 637.255 165.998 636.189 167.594C635.123 169.19 633.608 170.433 631.834 171.168C630.061 171.902 628.11 172.094 626.228 171.72C624.346 171.346 622.617 170.421 621.26 169.064C619.903 167.707 618.979 165.978 618.604 164.096C618.23 162.214 618.422 160.263 619.157 158.49C619.891 156.717 621.135 155.201 622.73 154.135C624.326 153.069 626.202 152.5 628.121 152.5C630.695 152.5 633.163 153.522 634.982 155.342C636.802 157.162 637.824 159.63 637.824 162.203Z",
    fill: "url(#paint162_radial_1825_22010)"
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M634.51 162.203C634.51 163.465 634.136 164.698 633.435 165.748C632.734 166.797 631.737 167.614 630.571 168.097C629.406 168.58 628.123 168.707 626.885 168.46C625.648 168.214 624.511 167.607 623.619 166.714C622.726 165.822 622.119 164.685 621.873 163.448C621.626 162.21 621.753 160.927 622.236 159.762C622.719 158.596 623.536 157.599 624.585 156.898C625.635 156.197 626.868 155.823 628.13 155.823C629.822 155.823 631.445 156.495 632.641 157.692C633.838 158.888 634.51 160.511 634.51 162.203Z",
    fill: "url(#paint163_linear_1825_22010)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M633.668 160.764C633.67 162.012 633.301 163.232 632.609 164.271C631.916 165.309 630.931 166.119 629.779 166.597C628.626 167.076 627.357 167.201 626.133 166.958C624.909 166.715 623.784 166.114 622.902 165.232C622.019 164.349 621.418 163.225 621.175 162C620.932 160.776 621.057 159.507 621.536 158.355C622.014 157.202 622.824 156.217 623.862 155.524C624.901 154.832 626.121 154.463 627.369 154.465C629.04 154.465 630.642 155.128 631.823 156.31C633.005 157.491 633.668 159.093 633.668 160.764Z",
    fill: "url(#paint164_radial_1825_22010)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M212.5 28.4913C212.502 34.0295 210.861 39.4439 207.785 44.0496C204.71 48.6553 200.337 52.2455 195.221 54.3661C190.105 56.4867 184.475 57.0424 179.043 55.963C173.611 54.8836 168.621 52.2176 164.704 48.3021C160.787 44.3865 158.12 39.3974 157.039 33.9657C155.958 28.534 156.512 22.9037 158.631 17.7869C160.75 12.67 164.338 8.29652 168.943 5.21946C173.548 2.14239 178.962 0.5 184.5 0.5C191.925 0.5 199.045 3.44879 204.296 8.69792C209.547 13.947 212.498 21.0667 212.5 28.4913Z",
    fill: "url(#paint165_radial_1825_22010)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M350.022 28.4913C350.024 34.0295 348.383 39.4439 345.308 44.0496C342.232 48.6553 337.86 52.2455 332.744 54.3661C327.627 56.4867 321.997 57.0424 316.565 55.963C311.133 54.8836 306.143 52.2176 302.227 48.3021C298.31 44.3865 295.642 39.3974 294.561 33.9657C293.48 28.534 294.034 22.9037 296.153 17.7869C298.272 12.67 301.861 8.29652 306.466 5.21946C311.07 2.14239 316.484 0.5 322.022 0.5C329.447 0.5 336.568 3.44879 341.818 8.69792C347.069 13.947 350.02 21.0667 350.022 28.4913Z",
    fill: "url(#paint166_radial_1825_22010)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M541.588 28.4913C541.59 34.0295 539.949 39.4439 536.874 44.0496C533.798 48.6553 529.426 52.2455 524.31 54.3661C519.193 56.4867 513.563 57.0424 508.131 55.963C502.699 54.8836 497.709 52.2176 493.792 48.3021C489.876 44.3865 487.208 39.3974 486.127 33.9657C485.046 28.534 485.6 22.9037 487.719 17.7869C489.838 12.67 493.427 8.29652 498.032 5.21946C502.636 2.14239 508.05 0.5 513.588 0.5C521.013 0.5 528.134 3.44879 533.384 8.69792C538.635 13.947 541.586 21.0667 541.588 28.4913Z",
    fill: "url(#paint167_radial_1825_22010)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M673.038 86.7105C673.039 92.2487 671.399 97.6631 668.323 102.269C665.247 106.875 660.875 110.465 655.759 112.585C650.643 114.706 645.012 115.262 639.58 114.182C634.148 113.103 629.158 110.437 625.242 106.521C621.325 102.606 618.657 97.6167 617.576 92.185C616.495 86.7533 617.049 81.123 619.168 76.0061C621.287 70.8893 624.876 66.5158 629.481 63.4387C634.086 60.3616 639.499 58.7192 645.038 58.7192C652.462 58.7192 659.583 61.668 664.834 66.9172C670.084 72.1663 673.035 79.286 673.038 86.7105Z",
    fill: "url(#paint168_radial_1825_22010)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 36.1944C56.5017 41.7326 54.861 47.147 51.7854 51.7527C48.7098 56.3584 44.3374 59.9486 39.2212 62.0692C34.105 64.1898 28.4749 64.7456 23.0428 63.6662C17.6108 62.5868 12.6208 59.9207 8.70409 56.0052C4.78735 52.0897 2.11975 47.1006 1.03866 41.6689C-0.0424356 36.2372 0.511569 30.6068 2.63057 25.49C4.74956 20.3732 8.33837 15.9996 12.9431 12.9226C17.5479 9.84552 22.9618 8.20313 28.5 8.20313C35.9245 8.20312 43.0452 11.1519 48.2959 16.401C53.5467 21.6502 56.4977 28.7698 56.5 36.1944Z",
    fill: "url(#paint169_radial_1825_22010)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M628.883 160.5C628.883 166.038 627.24 171.452 624.163 176.057C621.086 180.662 616.713 184.25 611.596 186.369C606.479 188.488 600.849 189.042 595.417 187.961C589.985 186.88 584.996 184.213 581.081 180.296C577.165 176.379 574.499 171.389 573.42 165.957C572.34 160.525 572.896 154.895 575.017 149.779C577.137 144.663 580.727 140.29 585.333 137.215C589.939 134.139 595.353 132.498 600.892 132.5C604.568 132.5 608.209 133.224 611.605 134.632C615.002 136.039 618.088 138.101 620.687 140.702C623.287 143.302 625.348 146.388 626.755 149.786C628.161 153.183 628.884 156.823 628.883 160.5Z",
    fill: "url(#paint170_radial_1825_22010)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M490.883 160.5C490.883 166.038 489.24 171.452 486.163 176.057C483.086 180.662 478.713 184.25 473.596 186.369C468.479 188.488 462.849 189.042 457.417 187.961C451.985 186.88 446.996 184.213 443.081 180.296C439.165 176.379 436.499 171.389 435.42 165.957C434.34 160.525 434.896 154.895 437.017 149.779C439.137 144.663 442.727 140.29 447.333 137.215C451.939 134.139 457.353 132.498 462.892 132.5C466.568 132.5 470.209 133.224 473.605 134.632C477.002 136.039 480.088 138.101 482.687 140.702C485.287 143.302 487.348 146.388 488.755 149.786C490.161 153.183 490.884 156.823 490.883 160.5Z",
    fill: "url(#paint171_radial_1825_22010)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M296.883 160.5C296.883 166.038 295.24 171.452 292.163 176.057C289.086 180.662 284.713 184.25 279.596 186.369C274.479 188.488 268.849 189.042 263.417 187.961C257.985 186.88 252.996 184.213 249.081 180.296C245.165 176.379 242.499 171.389 241.42 165.957C240.34 160.525 240.896 154.895 243.017 149.779C245.137 144.663 248.727 140.29 253.333 137.215C257.939 134.139 263.353 132.498 268.892 132.5C272.568 132.5 276.209 133.224 279.605 134.632C283.002 136.039 286.088 138.101 288.687 140.702C291.287 143.302 293.348 146.388 294.755 149.786C296.161 153.183 296.884 156.823 296.883 160.5Z",
    fill: "url(#paint172_radial_1825_22010)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M106.883 162.5C106.883 168.038 105.24 173.452 102.163 178.057C99.0863 182.662 94.7128 186.25 89.596 188.369C84.4791 190.488 78.8488 191.042 73.4171 189.961C67.9854 188.88 62.9963 186.213 59.0808 182.296C55.1653 178.379 52.4992 173.389 51.4198 167.957C50.3404 162.525 50.8961 156.895 53.0167 151.779C55.1373 146.663 58.7275 142.29 63.3332 139.215C67.9389 136.139 73.3533 134.498 78.8916 134.5C82.5682 134.5 86.2087 135.224 89.6053 136.632C93.002 138.039 96.0881 140.101 98.6875 142.702C101.287 145.302 103.348 148.388 104.755 151.786C106.161 155.183 106.884 158.823 106.883 162.5Z",
    fill: "url(#paint173_radial_1825_22010)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1825_22010",
    x1: 16.8826,
    y1: 12.5,
    x2: 251.02,
    y2: 416.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3985"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1825_22010",
    x1: 336.883,
    y1: 12.5,
    x2: 336.883,
    y2: 178.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2917FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FFF66",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(335.628 68.0899) scale(334.11 73.2695)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F4158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010D22"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.7711 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.771 27.9063) scale(6.37987 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.0024 26.467) scale(8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.216 36.1703) scale(12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.2159 36.1702) scale(6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.4482 34.7309) scale(8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.216 62.3526) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.2159 62.3528) scale(6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.4482 60.9216) scale(8.06985 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.216 88.5433) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.2159 88.5435) scale(6.37987 6.37988)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.4482 87.104) scale(8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.216 114.726) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.2159 114.726) scale(6.37987 6.37988)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.4482 113.295) scale(8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0761 140.916) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0757 140.917) scale(6.37988)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3078 139.477) scale(8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(644.182 34.5531) rotate(180) scale(12.4202 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(644.191 34.553) rotate(180) scale(6.37986 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(644.95 33.1137) rotate(180) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(644.182 60.7355) rotate(180) scale(12.4202 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(644.191 60.7356) rotate(180) scale(6.37986 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(644.95 59.3044) rotate(180) scale(8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(644.182 86.9262) rotate(180) scale(12.4202 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(644.191 86.9261) rotate(180) scale(6.37986 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(644.95 85.487) rotate(180) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(644.182 113.109) rotate(180) scale(12.4202 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(644.191 113.109) rotate(180) scale(6.37986 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(644.95 111.678) rotate(180) scale(8.06985 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(642.331 139.299) rotate(180) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(642.331 139.299) rotate(180) scale(6.37989 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(643.091 137.86) rotate(180) scale(8.06984 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.1422 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.1421 27.9063) scale(6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.3821 26.467) scale(8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.522 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.521 27.9063) scale(6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.753 26.467) scale(8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.893 27.9061) scale(12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.892 27.9063) scale(6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.124 26.467) scale(8.06985 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.272 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.263 27.9063) scale(6.37988 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.503 26.467) scale(8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(186.642 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(186.643 27.9063) scale(6.37987 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.875 26.467) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(214.014 27.9061) scale(12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(214.014 27.9063) scale(6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(213.246 26.467) scale(8.06985 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(241.393 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(241.386 27.9063) scale(6.37988 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.625 26.467) scale(8.06985 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(268.765 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(268.765 27.9063) scale(6.37988 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(267.997 26.467) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(294.656 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(294.656 27.9063) scale(6.37988 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(293.896 26.467) scale(8.06985 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(322.035 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(322.035 27.9063) scale(6.37988 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(321.267 26.467) scale(8.06985 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(349.406 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(349.407 27.9063) scale(6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(348.638 26.467) scale(8.06985 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(376.786 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(376.778 27.9063) scale(6.37988 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(376.018 26.467) scale(8.06985 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(404.157 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(404.157 27.9063) scale(6.37988 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(403.389 26.467) scale(8.06985 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(431.528 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(431.528 27.9063) scale(6.37987 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(430.76 26.467) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(458.908 27.9061) scale(12.4202 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(458.899 27.9063) scale(6.37986 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(458.139 26.467) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(486.279 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(486.279 27.9063) scale(6.37989 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(485.51 26.467) scale(8.06984 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.44 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.432 27.9063) scale(6.37986 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(512.671 26.467) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(540.81 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(540.811 27.9063) scale(6.37989 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(540.043 26.467) scale(8.06983 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(568.182 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(568.182 27.9063) scale(6.37987 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(567.414 26.467) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(595.561 27.9061) scale(12.4202 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(595.553 27.9063) scale(6.37986 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(594.793 26.467) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(622.933 27.9061) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(622.932 27.9063) scale(6.37989 6.37987)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FFEF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FDD509"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FBBE10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#F9A01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8951D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(622.165 26.467) scale(8.06984 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.5939 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1825_22010",
    x1: 46.2146,
    y1: 155.823,
    x2: 61.6052,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.8259 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80.0004 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1825_22010",
    x1: 73.6211,
    y1: 155.823,
    x2: 89.0117,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(79.2324 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.407 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_1825_22010",
    x1: 101.028,
    y1: 155.823,
    x2: 116.418,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.639 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.813 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_1825_22010",
    x1: 128.434,
    y1: 155.823,
    x2: 143.825,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.045 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(162.22 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_1825_22010",
    x1: 155.84,
    y1: 155.823,
    x2: 171.231,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(161.452 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(189.626 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_1825_22010",
    x1: 183.247,
    y1: 155.823,
    x2: 198.637,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(188.858 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(217.033 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_1825_22010",
    x1: 210.653,
    y1: 155.823,
    x2: 226.044,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(216.265 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(244.439 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_1825_22010",
    x1: 238.06,
    y1: 155.823,
    x2: 253.45,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(243.671 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(271.846 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_1825_22010",
    x1: 265.466,
    y1: 155.823,
    x2: 280.857,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(271.078 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(299.252 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_1825_22010",
    x1: 292.873,
    y1: 155.823,
    x2: 308.263,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(298.484 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.658 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_1825_22010",
    x1: 320.279,
    y1: 155.823,
    x2: 335.67,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(325.89 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(354.065 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_1825_22010",
    x1: 347.686,
    y1: 155.823,
    x2: 363.076,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(353.297 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(381.471 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_1825_22010",
    x1: 375.092,
    y1: 155.823,
    x2: 390.483,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(380.703 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(408.878 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_1825_22010",
    x1: 402.499,
    y1: 155.823,
    x2: 417.889,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(408.11 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(436.284 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_1825_22010",
    x1: 429.905,
    y1: 155.823,
    x2: 445.296,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(435.516 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(463.691 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_1825_22010",
    x1: 457.312,
    y1: 155.823,
    x2: 472.702,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(462.923 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(491.097 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_1825_22010",
    x1: 484.718,
    y1: 155.823,
    x2: 500.108,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(490.329 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(518.504 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_1825_22010",
    x1: 512.124,
    y1: 155.823,
    x2: 527.515,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(517.736 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(545.91 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_1825_22010",
    x1: 539.531,
    y1: 155.823,
    x2: 554.921,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(545.142 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(573.317 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_1825_22010",
    x1: 566.937,
    y1: 155.823,
    x2: 582.328,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(572.549 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(600.723 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_1825_22010",
    x1: 594.344,
    y1: 155.823,
    x2: 609.734,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(599.955 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(628.129 162.203) scale(12.4201 12.4201)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_1825_22010",
    x1: 621.75,
    y1: 155.823,
    x2: 637.141,
    y2: 162.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6CAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7366FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(627.361 160.772) scale(8.06986 8.06985)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184.5 28.5) rotate(90) scale(28 28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(322.022 28.5) rotate(90) scale(28 28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(513.588 28.5) rotate(90) scale(28 28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(645.038 86.7192) rotate(90) scale(28 28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5 36.2031) rotate(90) scale(28 28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(600.883 160.5) rotate(90) scale(28 28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(462.883 160.5) rotate(90) scale(28 28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(268.883 160.5) rotate(90) scale(28 28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_1825_22010",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.8828 162.5) rotate(90) scale(28 28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineSlot);
export default __webpack_public_path__ + "static/media/MachineSlot.b1dcd458d96e2759bb73d0fb85e7c3a6.svg";
export { ForwardRef as ReactComponent };